/* eslint-disable */
import React, { useState, useEffect, useRef, useMemo } from "react";
import { db } from "../../firebase-config";
import { ref, onValue, get, set, runTransaction, query, orderByChild, limitToLast, endBefore, onChildAdded, onChildChanged, onChildRemoved, off } from "firebase/database";
import "./AssignDoctor.css";
import "../../components/Chat/ChatNot.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { ToastContainer, toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import { saveAs } from "file-saver";
import CryptoJS from "crypto-js";
import DownloadIcon from "@mui/icons-material/Download";
import ShareIcon from "@mui/icons-material/Share";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";
import HistoryIcon from "@mui/icons-material/History";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import FileDownloadOffOutlinedIcon from "@mui/icons-material/FileDownloadOffOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import AddPatient from "../AddPatient/AddPatient";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { faBookMedical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MinimizeIcon from "@mui/icons-material/Minimize";
//deepaforaudit logs - Import audit logging functions including report finalization
import { logBulkAssignmentAdmin, logIndividualAssignmentAdmin, logShareEventAdmin, logDownloadReportAdmin, logDeletePatientAdmin, logExportDataAdmin, logViewReportAdmin, logReportFinalizeAdmin } from "../AuditLogs/AdminAuditLogs.jsx";
import DoctorAssignmentLogs from "../AuditLogs/DoctorAssignmentLogs";
import DropdownCell from "../../components/DropdownCell/DropdownCell";
import Tooltip from "@mui/material/Tooltip";
import { faPrescription } from "@fortawesome/free-solid-svg-icons";
// at the top, alongside your other firebase imports:
import {
  getStorage,
  ref as storageRef,
  listAll,
  deleteObject,
} from "firebase/storage";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

// ---- Import the new AI architecture classes/config:
import { AIModelHandler } from "../../API/AIModelHandler"; // <-- Update with the correct path
// -----------------------------------------------------

// =====================
//   Encryption Helpers
// =====================
const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";

const isBase64 = (str) => {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};

const decrypt = (encryptedData) => {
  try {
    if (!isBase64(encryptedData)) {
      return encryptedData; // If it's not base64, it's probably plain
    }
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || encryptedData;
  } catch (error) {
    return encryptedData;
  }
};

const encrypt = (data) => {
  try {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return data; // Return original if encryption fails
  }
};

const getDecryptedFilePath = (filePath) => {
  try {
    if (typeof filePath === "string" && isBase64(filePath)) {
      const bytes = CryptoJS.AES.decrypt(filePath, secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted || filePath;
    }
    return filePath;
  } catch (error) {
    console.error("Error decrypting file path:", error);
    return filePath;
  }
};

// Function to decrypt keys and make them Firebase-safe
const decryptKey = (encryptedKey) => {
  try {
    // Return early if not a string or empty
    if (typeof encryptedKey !== 'string' || !encryptedKey) {
      return encryptedKey;
    }
    
    const base64String = encryptedKey.replace(/_/g, '/').replace(/-/g, '+');
    
    // Validate if it looks like a base64 string before attempting to decode
    // Base64 should only contain A-Z, a-z, 0-9, +, /, and optional = padding
    if (!/^[A-Za-z0-9+/]+={0,2}$/.test(base64String)) {
      return encryptedKey; // Not base64, return as-is
    }
    
    const encrypted = atob(base64String);
    return decrypt(encrypted);
  } catch (error) {
    // Silently return original key without logging if it's just a plain text key
    return encryptedKey;
  }
};

const decryptField = (field) => {
  if (!field) return "";
  if (Array.isArray(field)) {
    return field.map((item) => decrypt(item));
  }
  return decrypt(field);
};

// Helper function to get patient data (handles both encrypted and plain text)
const getPatientData = (patientData, fieldName) => {
  if (!patientData) return null;
  
  // First try direct field access (for legacy plain text data)
  if (patientData[fieldName] !== undefined && patientData[fieldName] !== null) {
    return decryptField(patientData[fieldName]);
  }
  
  // Then try to find encrypted key version
  for (const key in patientData) {
    try {
      const decryptedKey = decryptKey(key);
      if (decryptedKey === fieldName) {
        return decryptField(patientData[key]);
      }
    } catch (error) {
      continue; // Continue to next key if decryption fails
    }
  }
  
  return null;
};

// Function to format date as DD/MM/YYYY, HH:mm:ss
const formatDate = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based, so add 1
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
};

// ============
// Main Start
// ============
const AssignDoctor = () => {
  const navigate = useNavigate();
  const { logOut } = useUserAuth();
  const adminName1 = localStorage.getItem("adminName");

  // ==============
  //   State
  // ==============

  const [posts, setPosts] = useState([]);
  const [doctors, setDoctors] = useState({});
    // deepa bug fix - Add loading state for better UX
  const [isLoadingPatients, setIsLoadingPatients] = useState(true);
  
  /* BATCH LOADING SYSTEM - Loads patients in batches of 100 */
  const [batchSize] = useState(100);
  const [loadedBatches, setLoadedBatches] = useState(new Set());
  const [totalPatientCount, setTotalPatientCount] = useState(0);
  const [isLoadingBatch, setIsLoadingBatch] = useState(false);
  const [allPatientKeys, setAllPatientKeys] = useState([]);
  const [hasMorePatients, setHasMorePatients] = useState(true);
  const [oldestTimestamp, setOldestTimestamp] = useState(null);
  const [isSearchingFirebase, setIsSearchingFirebase] = useState(false);
  const [isInitialBatchLoaded, setIsInitialBatchLoaded] = useState(false);
  const [searchTerms, setSearchTerms] = useState({
    patientId: "",
    fullName: "",
    modality: "",
    centerName: "",
    status: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLink, setSelectedLink] = useState("");
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [bulkAssignModalVisible, setBulkAssignModalVisible] = useState(false);
  const [unassignedPatients, setUnassignedPatients] = useState([]);
  const [bulkSelectedPatients, setBulkSelectedPatients] = useState([]);
  const [bulkSelectedDoctor, setBulkSelectedDoctor] = useState("");
  const [clinicalHistoryModalVisible, setClinicalHistoryModalVisible] =
    useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState("");
  const [clinicalHistoryText, setClinicalHistoryText] = useState("");
  const [attachedFile, setAttachedFile] = useState(null);
  const [selectedDropdownId, setSelectedDropdownId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [patientsPerPage] = useState(20);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filteredPostIds, setFilteredPostIds] = useState([]);

  // AI model stuff
  const [aiModalVisible, setAiModalVisible] = useState(false);
  const [aiModalPatientId, setAiModalPatientId] = useState(null);
  const [aiModelsEnabled, setAiModelsEnabled] = useState({});
  const [costingType, setCostingType] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);
  // New model cost state variables
  const [cxrTbCost, setCxrTbCost] = useState(0);
  const [cxrTb2Cost, setCxrTb2Cost] = useState(0);
  const [cxrMulticlassCost, setCxrMulticlassCost] = useState(0);
  const [xrayFractureCost, setXrayFractureCost] = useState(0);
  const [threeDAbdomenCost, setThreeDAbdomenCost] = useState(0);
  const [contourHaNModelCost, setContourHaNModelCost] = useState(0);
  const [tumorAbdomenCost, setTumorAbdomenCost] = useState(0);
  const [contourAbdomenCost, setContourAbdomenCost] = useState(0);
  const [liverSegmentationCost, setLiverSegmentationCost] = useState(0);
  const [boneFractureCost, setBoneFractureCost] = useState(0);
  const [contouringModelCost, setContouringModelCost] = useState(0);
  const [tbModelCost, setTbModelCost] = useState(0);

  // We'll keep an array "aiTasks" describing each active or completed AI request
  // => an array of { patientId, model, subModel, status }
  const [aiTasks, setAiTasks] = useState([]);
  const intervalsRef = useRef({});

  // For the AI Processing Status modal
  const [aiProcessingModalOpen, setAiProcessingModalOpen] = useState(false);
  const [aiProcessingModalMinimized, setAiProcessingModalMinimized] =
    useState(false);

  // Add this with the other state variables (around line 120, near aiModalVisible)
  const [showContouringSubMenu, setShowContouringSubMenu] = useState(false);

  // Add state for insufficient balance modal
  const [insufficientBalanceModal, setInsufficientBalanceModal] = useState({
    open: false,
    patientId: null,
  });

  // Add state for audit logs modal
  const [showAuditLogs, setShowAuditLogs] = useState(false);

 
  //Viniith Added Code to Resolve #!
  const patientFullNameLink = (patientId, patient) => {
    const encryptedAdminName = window.btoa(adminName1);
    const encryptedPatientId = window.btoa(patientId);
    const url = `/patient/${encryptedAdminName}/${encryptedPatientId}`;
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {patient.FullName}
      </a>
    );
  };


  //Viniith Added Code to Resolve #!
  const patientIDLink = (patient) => {
    // If no DICOM folder, show greyed-out ID
    if (!hasDicomFolder(patient)) {
      return <span style={{ color: "grey" }}>{patient.ID}</span>;
    }

    let folderPath;
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().startsWith("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan", "").trim(), 10),
        }))
        .sort((a, b) => b.number - a.number);
      for (const { key } of scanKeys) {
        const scanData = patient.uploads[key];
        if (scanData && scanData.FolderPath && scanData.FolderPath !== "NA") {
          folderPath = getDecryptedFilePath(scanData.FolderPath);
          break;
        }
      }
    } else {
      folderPath = getDecryptedFilePath(patient.FolderPath);
    }

    if (folderPath) {
      const viewerURL = `https://tryon.easiofy.com/DWV/?Patient=${folderPath}&View=Technician`;
      return (
        <a href={viewerURL} target="_blank" rel="noopener noreferrer">
          {patient.ID}
        </a>
      );
    }

    return <span style={{ color: "grey" }}>{patient.ID}</span>;
  };

  // ==============
  //    useEffect
  // ==============

  // 1. get wallet/costing
  useEffect(() => {
    if (adminName1) {
      // Wallet balance
      const walletBalanceRef = ref(
        db,
        `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
      );
      const unsubscribeWallet = onValue(walletBalanceRef, (snapshot) => {
        if (snapshot.exists()) {
          setWalletBalance(snapshot.val());
        }
      });

      // CXR-TB cost
      const cxrTbCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-TB`
      );
      get(cxrTbCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrTbCost(snapshot.val());
        } else {
          setCxrTbCost(0);
        }
      });

      // CXR-TB2 cost
      const cxrTb2CostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-TB2`
      );
      get(cxrTb2CostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrTb2Cost(snapshot.val());
        } else {
          setCxrTb2Cost(0);
        }
      });

      // CXR-Multiclass cost
      const cxrMulticlassCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-Multiclass`
      );
      get(cxrMulticlassCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrMulticlassCost(snapshot.val());
        } else {
          setCxrMulticlassCost(0);
        }
      });

      // XRay-Fracture cost
      const xrayFractureCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/XRay-Fracture`
      );
      get(xrayFractureCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setXrayFractureCost(snapshot.val());
        } else {
          setXrayFractureCost(0);
        }
      });

      // 3D-Abdomen cost
      const threeDAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/3D-Abdomen`
      );
      get(threeDAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setThreeDAbdomenCost(snapshot.val());
        } else {
          setThreeDAbdomenCost(0);
        }
      });



      // Tumor-Abdomen cost
      const tumorAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Tumor-Abdomen`
      );
      get(tumorAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setTumorAbdomenCost(snapshot.val());
        } else {
          setTumorAbdomenCost(0);
        }
      });

      // Contour-Abdomen cost
      const contourAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Contour-Abdomen`
      );
      get(contourAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setContourAbdomenCost(snapshot.val());
        } else {
          setContourAbdomenCost(0);
        }
      });

      // Contour-HaN cost
      const contourHaNModelCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Contour-HaN`
      );
      get(contourHaNModelCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setContourHaNModelCost(snapshot.val());
        } else {
          setContourHaNModelCost(0);
        }
      });

      // costingType
      const costingTypeRef = ref(
        db,
        `superadmin/admins/${adminName1}/CostingType`
      );
      get(costingTypeRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCostingType(snapshot.val());
        } else {
          setCostingType("");
        }
      });

      // Liver-Segmentation cost
      const liverSegmentationCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Liver-Segmentation`
      );
      get(liverSegmentationCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setLiverSegmentationCost(snapshot.val());
        } else {
          setLiverSegmentationCost(0);
        }
      });

      // Additional model costs are already fetched above

      return () => {
        unsubscribeWallet();
      };
    }
  }, [adminName1]);

  // 2. get ai models enabled
  useEffect(() => {
    if (adminName1) {
      const aiEnabledRef = ref(
        db,
        `superadmin/admins/${adminName1}/AI_Model_Enabled`
      );
      onValue(aiEnabledRef, (snapshot) => {
        if (snapshot.exists()) {
          setAiModelsEnabled(snapshot.val());
        } else {
          setAiModelsEnabled({});
        }
      });
    }
  }, [adminName1]);

  // Helper function to process patient data
  const processPatientData = (id, patient) => {
    if (!patient) return null;
    
    // Clean up DoctorAssigned field - filter out invalid entries
    let cleanDoctorAssigned = [];
    if (patient.DoctorAssigned && Array.isArray(patient.DoctorAssigned)) {
      cleanDoctorAssigned = patient.DoctorAssigned.filter(doctor => {
        if (!doctor) return false;
        if (typeof doctor === 'string') {
          const cleanName = doctor.trim().toLowerCase();
          return cleanName !== '' && 
                 cleanName !== 'doctor common' && 
                 cleanName !== 'doctorcommon' &&
                 cleanName !== 'null' &&
                 cleanName !== 'undefined';
        }
        if (typeof doctor === 'object' && doctor.name) {
          const cleanName = doctor.name.trim().toLowerCase();
          return cleanName !== '' && 
                 cleanName !== 'doctor common' && 
                 cleanName !== 'doctorcommon' &&
                 cleanName !== 'null' &&
                 cleanName !== 'undefined';
        }
        return false;
      });
    }

    // Keep isPriority value even for finalized reports
    return {
      ...patient,
      FullName: patient.FullName ? decrypt(patient.FullName) : "",
      Age: patient.Age ? decrypt(patient.Age) : "",
      ID: patient.ID ? decrypt(patient.ID) : "",
      DoctorAssigned: cleanDoctorAssigned,
      isPriority: patient.isPriority || false,
    };
  };

  // Fetch patient keys using Firebase orderByChild query
  const fetchPatientKeys = async () => {
    if (!adminName1) return;
    
    try {
      
      // Create a query to get latest 100 patients sorted by Timestamp
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const latestQuery = query(
        patientsRef,
        orderByChild('Timestamp'),
        limitToLast(100)
      );
      
      const snapshot = await get(latestQuery);
      const latestPatients = snapshot.val();
      
      if (!latestPatients) {
        setTotalPatientCount(0);
        setAllPatientKeys([]);
        setPosts({});
        setIsLoadingPatients(false);
        return;
      }
      
      // Convert to array and sort
      const keysWithTimestamp = Object.keys(latestPatients).map(id => ({
        id,
        timestamp: latestPatients[id]?.Timestamp || "1970-01-01T00:00:00"
      }));
      
      keysWithTimestamp.sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB - dateA;
      });
      
      const sortedKeys = keysWithTimestamp.map(item => item.id);
      
      // Track the oldest timestamp for loading more patients
      if (keysWithTimestamp.length > 0) {
        const oldestPatient = keysWithTimestamp[keysWithTimestamp.length - 1];
        setOldestTimestamp(oldestPatient.timestamp);
      }
      
      // Check if we got fewer than 100 patients (means no more to load)
      setHasMorePatients(keysWithTimestamp.length >= 100);
      
      // Process and decrypt patient data before storing
      const processedPatients = {};
      Object.keys(latestPatients).forEach((patientId) => {
        const processed = processPatientData(patientId, latestPatients[patientId]);
        if (processed) {
          processedPatients[patientId] = processed;
        }
      });
      
      setAllPatientKeys(sortedKeys);
      setTotalPatientCount(sortedKeys.length);
      setPosts(processedPatients);
      setIsInitialBatchLoaded(true); // Mark initial batch as loaded
      
    } catch (error) {
      console.error("Error fetching patients:", error);
      setIsLoadingPatients(false);
    }
  };

  // Load a specific batch of patients
  const loadPatientBatch = async (batchNumber) => {
    if (!adminName1 || loadedBatches.has(batchNumber) || isLoadingBatch || allPatientKeys.length === 0) {
      return;
    }

    setIsLoadingBatch(true);
    
    try {
      const startIndex = batchNumber * batchSize;
      const endIndex = Math.min(startIndex + batchSize, allPatientKeys.length);
      const batchKeys = allPatientKeys.slice(startIndex, endIndex);

      const batchData = {};
      
      // Data is already processed and stored in posts, just use it directly
      batchKeys.forEach((patientId) => {
        if (posts[patientId]) {
          batchData[patientId] = posts[patientId];
        }
      });

      setPosts((prevPosts) => ({
        ...prevPosts,
        ...batchData,
      }));

      setLoadedBatches((prev) => new Set([...prev, batchNumber]));
    } catch (error) {
      console.error("Error loading patient batch:", error);
    } finally {
      setIsLoadingBatch(false);
      setIsLoadingPatients(false);
    }
  };

  // Load more patients (next 100)
  const loadMorePatients = async () => {
    if (!adminName1 || !hasMorePatients || isLoadingBatch || !oldestTimestamp) return;
    
    try {
      setIsLoadingBatch(true);
      
      // Query for next 100 patients before the oldest timestamp
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const nextQuery = query(
        patientsRef,
        orderByChild('Timestamp'),
        endBefore(oldestTimestamp),
        limitToLast(100)
      );
      
      const snapshot = await get(nextQuery);
      const morePatients = snapshot.val();
      
      if (!morePatients || Object.keys(morePatients).length === 0) {
        setHasMorePatients(false);
        setIsLoadingBatch(false);
        return;
      }
      
      // Convert to array and sort
      const keysWithTimestamp = Object.keys(morePatients).map(id => ({
        id,
        timestamp: morePatients[id]?.Timestamp || "1970-01-01T00:00:00"
      }));
      
      keysWithTimestamp.sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB - dateA;
      });
      
      const newKeys = keysWithTimestamp.map(item => item.id);
      
      // Update oldest timestamp for next load
      if (keysWithTimestamp.length > 0) {
        const oldestPatient = keysWithTimestamp[keysWithTimestamp.length - 1];
        setOldestTimestamp(oldestPatient.timestamp);
      }
      
      // Check if there are more patients
      setHasMorePatients(keysWithTimestamp.length >= 100);
      
      // Process and decrypt patient data before storing
      const processedMorePatients = {};
      Object.keys(morePatients).forEach((patientId) => {
        const processed = processPatientData(patientId, morePatients[patientId]);
        if (processed) {
          processedMorePatients[patientId] = processed;
        }
      });
      
      // Append new patients to existing
      setAllPatientKeys(prev => [...prev, ...newKeys]);
      setTotalPatientCount(prev => prev + newKeys.length);
      setPosts(prev => ({ ...prev, ...processedMorePatients }));
      
    } catch (error) {
      console.error("Error loading more patients:", error);
    } finally {
      setIsLoadingBatch(false);
    }
  };

  // Fetch patient keys on mount
  useEffect(() => {
    if (adminName1) {
      setIsInitialBatchLoaded(false); // Reset initial batch flag
      fetchPatientKeys();
    }
  }, [adminName1]);

  /* Global real-time listener for all patient changes */
  useEffect(() => {
    if (!adminName1) return;

    const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
    
    // Track if this is the initial mount to prevent duplicate additions
    let isInitialLoad = true;
    const initialLoadTimer = setTimeout(() => {
      isInitialLoad = false;
    }, 2000); // Increased timeout to ensure initial batch load completes

    // Listen for new patients being added
    const handleChildAdded = onChildAdded(patientsRef, (snapshot) => {
      // Skip initial load to prevent duplicates
      if (isInitialLoad) return;
      
      const patientId = snapshot.key;
      const patientData = snapshot.val();
      
      // Check if we already have this patient
      setPosts(prev => {
        if (prev[patientId]) {
          return prev; // Already exists, don't add
        }
        
        // Only add new patients if initial batch is loaded (allow real-time updates after initial load)
        if (!isInitialBatchLoaded) {
          return prev; // Don't add during initial batch loading
        }
        
        // Allow real-time updates to show immediately after initial batch is loaded
        
        // Process and add new patient to top
        const processed = processPatientData(patientId, patientData);
        if (processed) {
          // Add to top of the list
          const updated = { [patientId]: processed, ...prev };
          
          // Update patient keys and count
          setAllPatientKeys(prevKeys => {
            if (!prevKeys.includes(patientId)) {
              return [patientId, ...prevKeys];
            }
            return prevKeys;
          });
          setTotalPatientCount(prevCount => {
            const currentCount = Object.keys(updated).length;
            return currentCount;
          });
          
          return updated;
        }
        return prev;
      });
    });

    // Listen for patient data changes
    const handleChildChanged = onChildChanged(patientsRef, (snapshot) => {
      const patientId = snapshot.key;
      const patientData = snapshot.val();
      
      setPosts(prev => {
        const exists = prev[patientId];
        
        // Update existing patient data
        const processed = processPatientData(patientId, patientData);
        if (processed) {
          if (exists) {
            // Update existing patient
            return { ...prev, [patientId]: processed };
          } else {
            // Patient was added (shouldn't happen often, but handle it) - allow after initial load
            if (!isInitialBatchLoaded) {
              return prev; // Don't add during initial batch loading
            }
            
            // Allow real-time updates to show immediately after initial batch is loaded
            setAllPatientKeys(prevKeys => {
              if (!prevKeys.includes(patientId)) {
                return [patientId, ...prevKeys];
              }
              return prevKeys;
            });
            setTotalPatientCount(prevCount => prevCount + 1);
            return { [patientId]: processed, ...prev };
          }
        }
        
        return prev;
      });
    });

    // Listen for patient deletions
    const handleChildRemoved = onChildRemoved(patientsRef, (snapshot) => {
      const patientId = snapshot.key;
      
      setPosts(prev => {
        const exists = prev[patientId];
        if (exists) {
          const updated = { ...prev };
          delete updated[patientId];
          
          setAllPatientKeys(prevKeys => prevKeys.filter(key => key !== patientId));
          setTotalPatientCount(prevCount => Math.max(0, prevCount - 1));
          return updated;
        }
        return prev;
      });
    });

    // Cleanup function
    return () => {
      clearTimeout(initialLoadTimer);
      off(patientsRef, 'child_added', handleChildAdded);
      off(patientsRef, 'child_changed', handleChildChanged);
      off(patientsRef, 'child_removed', handleChildRemoved);
    };
  }, [adminName1, isInitialBatchLoaded, patientsPerPage]);

  // Load initial batch after keys are fetched
  useEffect(() => {
    if (adminName1 && allPatientKeys.length > 0 && loadedBatches.size === 0) {
      loadPatientBatch(0);
    }
  }, [adminName1, allPatientKeys]);

  // Load additional batches based on current page
  useEffect(() => {
    if (!adminName1 || allPatientKeys.length === 0) return;

    const requiredBatch = Math.floor(((currentPage - 1) * patientsPerPage) / batchSize);
    
    if (!loadedBatches.has(requiredBatch)) {
      loadPatientBatch(requiredBatch);
    }

    const nextBatch = requiredBatch + 1;
    const maxBatch = Math.ceil(allPatientKeys.length / batchSize) - 1;
    if (nextBatch <= maxBatch && !loadedBatches.has(nextBatch)) {
      setTimeout(() => loadPatientBatch(nextBatch), 500);
    }
  }, [currentPage, adminName1, loadedBatches, allPatientKeys]);

  // 4. get doctors
  useEffect(() => {
    const docRef = ref(db, `superadmin/admins/${adminName1}/doctors`);
    onValue(docRef, (snapshot) => {
      if (snapshot.exists()) {
        setDoctors(snapshot.val());
      } else {
        setDoctors({});
      }
    });
  }, [adminName1]);

  // 5. unassigned patients
  useEffect(() => {
    const unassigned = Object.keys(posts).filter(
      (id) => !posts[id].DoctorAssigned || posts[id].DoctorAssigned.length === 0
    );
    setUnassignedPatients(unassigned);
  }, [posts]);

  // 6. handle outside click for doctor dropdown
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSelectedDropdownId(null);
      }
    }
    if (selectedDropdownId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedDropdownId]);

  // 7. unmount => clear intervals
  useEffect(() => {
    return () => {
      Object.values(intervalsRef.current).forEach(clearInterval);
    };
  }, []);

  // 8. filtered posts on search
  useEffect(() => {
    const newFiltered = Object.keys(posts || {}).filter((id) => {
      const patient = posts[id];
      // deepa fix issue patient delete - guard against null patient object
                      if (!patient) {
                        return null;
                      }
      const fullName = (patient?.FullName || "").toLowerCase();
      const patientId = (patient?.ID || "").toLowerCase();
      const patientModality = (getLatestModality(patient) || "n/a")
        .trim()
        .toLowerCase();
      const centerName = (patient?.Addedby || "").toLowerCase();
      const status = (patient?.Report_Status || "").toLowerCase();

      const searchFullName = (searchTerms.fullName || "").toLowerCase();
      const searchPatientId = (searchTerms.patientId || "").toLowerCase();
      const searchModality = (searchTerms.modality || "").toLowerCase();
      const searchCenterName = (searchTerms.centerName || "").toLowerCase();
      const searchStatus = (searchTerms.status || "").toLowerCase();

      let modalityMatch = true;
      if (searchModality) {
        if (searchModality === "na") {
          // Looking for NA
          modalityMatch = patientModality === "na" || patientModality === "n/a";
        } else {
          modalityMatch = patientModality === searchModality;
        }
      }

      return (
        fullName.includes(searchFullName) &&
        patientId.includes(searchPatientId) &&
        modalityMatch &&
        (!searchCenterName || centerName === searchCenterName) &&
        (!searchStatus || status === searchStatus)
      );
    });
    setFilteredPostIds(newFiltered);
  }, [posts, searchTerms]);

  // Search Firebase for specific patient by Name or ID
  const searchPatientInFirebase = async (searchName, searchId) => {
    if (!adminName1 || (!searchName && !searchId) || isSearchingFirebase) return;
    
    setIsSearchingFirebase(true);
    
    try {
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const snapshot = await get(patientsRef);
      const allPatients = snapshot.val();
      
      if (!allPatients) {
        setIsSearchingFirebase(false);
        return;
      }
      
      const foundPatients = {};
      Object.keys(allPatients).forEach((patientId) => {
        const patient = allPatients[patientId];
        const decryptedName = patient.FullName ? decrypt(patient.FullName) : "";
        const decryptedId = patient.ID ? decrypt(patient.ID) : "";
        
        const matchesName = searchName ? decryptedName.toLowerCase().includes(searchName.toLowerCase().trim()) : true;
        const matchesId = searchId ? decryptedId.toLowerCase().includes(searchId.toLowerCase().trim()) : true;
        
        if (matchesName && matchesId) {
          const processed = processPatientData(patientId, patient);
          if (processed) {
            foundPatients[patientId] = processed;
          }
        }
      });
      
      // Add found patients to posts if not already present
      if (Object.keys(foundPatients).length > 0) {
        setPosts(prev => ({ ...prev, ...foundPatients }));
      } else {
        toast.info("No matching patients found", {
          position: "top-center",
          autoClose: 2000
        });
      }
    } catch (error) {
      console.error("Error searching patient in Firebase:", error);
      toast.error("Error searching database", {
        position: "top-center"
      });
    } finally {
      setIsSearchingFirebase(false);
    }
  };

  // Viniith Fix this 05-08-2025 - Reset to page 1 when any search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerms]);

  // Search Firebase if patient not found in loaded data
  useEffect(() => {
    const hasSearchTerm = searchTerms.fullName.trim() || searchTerms.patientId.trim();
    
    if (hasSearchTerm && filteredPostIds.length === 0 && Object.keys(posts).length > 0 && !isSearchingFirebase) {
      // No results found in current data, search Firebase after a small delay
      const timeoutId = setTimeout(() => {
        searchPatientInFirebase(searchTerms.fullName, searchTerms.patientId);
      }, 500); // 500ms delay to avoid searching on every keystroke
      
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerms.fullName, searchTerms.patientId]);

  // ==============
  //   Pagination
  // ==============
  const indexOfLastPatient = currentPage * patientsPerPage;
  const indexOfFirstPatient = indexOfLastPatient - patientsPerPage;

  const parseTimestamp = (timestamp) => {
    if (!timestamp) return new Date(0);
    
    // Try parsing as ISO format first (YYYY-MM-DDTHH:mm:ss.sssZ)
    const isoDate = new Date(timestamp);
    if (!isNaN(isoDate.getTime())) {
      return isoDate; // Valid ISO format
    }
    
    // Fallback: Try parsing old format (dd/mm/yyyy, hh:mm:ss)
    if (timestamp.includes(",")) {
      const [datePart, timePart] = timestamp.split(", ");
      const [day, month, year] = datePart.split("/").map(Number);
      const [hours = 0, minutes = 0, seconds = 0] = timePart
        ? timePart.split(":").map(Number)
        : [0, 0, 0];
      return new Date(year, month - 1, day, hours, minutes, seconds);
    }
    
    return new Date(0); // Invalid format
  };

  // Format timestamp for display (converts ISO to dd/mm/yyyy, hh:mm:ss)
  const formatTimestampForDisplay = (timestamp) => {
    if (!timestamp) return "NA";
    
    // If already in old format (contains comma), return as-is
    if (timestamp.includes(", ")) {
      return timestamp;
    }
    
    // Parse ISO format and convert to readable format
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return timestamp; // Return original if invalid
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  };

  const getLatestStudyDateFromUploads = (uploads) => {
    if (!uploads || typeof uploads !== "object") return null;
    const latestStudyDate = Object.keys(uploads).reduce((latestDate, key) => {
      const scan = uploads[key];
      if (scan.StudyDate) {
        const scanDate = new Date(
          scan.StudyDate.split("/").reverse().join("-")
        );
        return scanDate > latestDate ? scanDate : latestDate;
      }
      return latestDate;
    }, new Date(0));
    return latestStudyDate > new Date(0) ? latestStudyDate : null;
  };

  // Sort by Received time (Timestamp) - latest first
  const getSortingDate = (patient) => {
    if (!patient) return new Date(0); // fallback
    const timestampDate = parseTimestamp(patient.Timestamp); // Parse Timestamp (Received time)
    return timestampDate; // Sort by Received time only
  };

  const sortedFilteredPosts = useMemo(() => {
    const arr = filteredPostIds.sort((a, b) => {
      const dateA = getSortingDate(posts[a]);
      const dateB = getSortingDate(posts[b]);
      return (dateB || new Date(0)) - (dateA || new Date(0));
    });
    return arr;
  }, [filteredPostIds, posts]);

  const currentPatients = sortedFilteredPosts.slice(
    indexOfFirstPatient,
    indexOfLastPatient
  );
  
  const paginate = async (pageNumber) => {
    const currentTotalPages = Math.ceil(filteredPostIds.length / patientsPerPage);
    
    // If user is trying to go beyond current loaded pages and more patients exist
    if (pageNumber > currentTotalPages && hasMorePatients && !isLoadingBatch) {
      await loadMorePatients();
      // After loading, set to the first page of newly loaded data
      setCurrentPage(currentTotalPages + 1);
    } else {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate total pages, always add 1 extra if more patients can be loaded
  const totalPages = hasMorePatients 
    ? Math.ceil(filteredPostIds.length / patientsPerPage) + 1 
    : Math.ceil(filteredPostIds.length / patientsPerPage);

  // =====================
  //    Helper Functions
  // =====================

  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleSearch = (event) => {
    const { name, value } = event.target;
    setSearchTerms((prev) => ({ ...prev, [name]: value }));
  };

  //deepaaudit logs - Share modal open handler (no logging here)
  const handleShareClick = (id) => {
    try {
      const baseUrl =
        process.env.NODE_ENV === "development"
          ? "http://localhost:3000"
          : "https://tryon.easiofy.com";
      const generatedLink = `${baseUrl}/patient/${window.btoa(
        adminName1
      )}/${window.btoa(id)}`;
      setSelectedLink(generatedLink);
      setModalVisible(true);
    } catch (error) {
      console.error("Error in handleShareClick:", error);
      alert("Error generating share link");
    }
  };

  //deepaaudit logs - Modified to include audit logging for copy action
  //deepaaudit logs - Copy link handler with audit logging
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(selectedLink);
      alert("Link copied to clipboard!");
      setModalVisible(false);

      //deepaaudit logs - Extract patient ID from URL and get encrypted version
      const urlParts = selectedLink.split('/');
      const encryptedId = urlParts[urlParts.length - 1];
      const databaseId = window.atob(encryptedId);

      //deepaaudit logs - Get encrypted patient ID from posts or encrypt it
      const patient = posts[databaseId];
      const patientIdEncrypted = patient?.ID || encrypt(databaseId);

      //deepaaudit logs - Log successful copy event
      await logShareEventAdmin({
        adminName: adminName1,
        patientId: patientIdEncrypted,
        patientName: patient?.FullName || "Unknown",
        action: "copy",
        reportUrl: selectedLink,
        success: true
      });
    } catch (error) {
      console.error("Error copying to clipboard:", error);
      
      //deepaaudit logs - Extract patient ID from URL and get encrypted version
      const urlParts = selectedLink.split('/');
      const encryptedId = urlParts[urlParts.length - 1];
      const databaseId = window.atob(encryptedId);

      //deepaaudit logs - Get encrypted patient ID from posts or encrypt it
      const patient = posts[databaseId];
      const patientIdEncrypted = patient?.ID || encrypt(databaseId);

      //deepaaudit logs - Log failed copy event
      await logShareEventAdmin({
        adminName: adminName1,
        patientId: patientIdEncrypted,
        patientName: patient?.FullName || "Unknown",
        action: "copy",
        reportUrl: selectedLink,
        success: false,
        failureReason: error.message
      });
    }
  };

  //deepaaudit logs - Modified to include audit logging for WhatsApp share
  const shareViaWhatsApp = async () => {
    try {
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        "Click this link to View your Data: " + selectedLink
      )}`;
      window.open(whatsappUrl, "_blank");
      setModalVisible(false);

      //deepaaudit logs - Extract patient ID from URL and get encrypted version
      const urlParts = selectedLink.split('/');
      const encryptedId = urlParts[urlParts.length - 1];
      const databaseId = window.atob(encryptedId);

      //deepaaudit logs - Get encrypted patient ID from posts or encrypt it
      const patient = posts[databaseId];
      const patientIdEncrypted = patient?.ID || encrypt(databaseId);

      //deepaaudit logs - Log successful WhatsApp share event
      await logShareEventAdmin({
        adminName: adminName1,
        patientId: patientIdEncrypted,
        patientName: patient?.FullName || "Unknown",
        action: "whatsapp",
        reportUrl: selectedLink,
        success: true
      });
    } catch (error) {
      console.error("Error sharing via WhatsApp:", error);

      //deepaaudit logs - Extract patient ID from URL and get encrypted version
      const urlParts = selectedLink.split('/');
      const encryptedId = urlParts[urlParts.length - 1];
      const databaseId = window.atob(encryptedId);

      //deepaaudit logs - Get encrypted patient ID from posts or encrypt it
      const patient = posts[databaseId];
      const patientIdEncrypted = patient?.ID || encrypt(databaseId);

      //deepaaudit logs - Log failed WhatsApp share event
      await logShareEventAdmin({
        adminName: adminName1,
        patientId: patientIdEncrypted,
        patientName: patient?.FullName || "Unknown",
        action: "whatsapp",
        reportUrl: selectedLink,
        success: false,
        failureReason: error.message
      });
    }
  };

  // getLatestModality
  const getLatestModality = (patient) => {
    if (!patient) return "N/A";

    let modalityValue = "N/A";
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().startsWith("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan", "").trim(), 10),
        }))
        .sort((a, b) => b.number - a.number);

      for (const { key } of scanKeys) {
        const scan = patient.uploads[key];
        if (
          scan.Modality &&
          typeof scan.Modality === "string" &&
          scan.Modality.trim() !== ""
        ) {
          modalityValue = scan.Modality.trim();
          break;
        }
      }
    }
    if (modalityValue === "N/A" && patient.Modality) {
      if (Array.isArray(patient.Modality)) {
        modalityValue =
          patient.Modality.length > 0 ? patient.Modality[0] : "N/A";
      } else if (typeof patient.Modality === "string") {
        modalityValue = patient.Modality;
      }
    }
    return modalityValue;
  };

  // Helper function to get AI classification from patient data
  const getAIClassification = (patient) => {
    try {
      // Check if modality is XRAY-related first
      const modality = (getLatestModality(patient) || "").toLowerCase();
      const isXrayModality = modality.includes("xr") || 
                            modality.includes("x ray") || 
                            modality.includes("x-ray") || 
                            modality.includes("xray");
      
      // Only process XRAY modality, others show "-"
      if (!isXrayModality) {
        return "-";
      }
      
      // Check if AI has been run (AI_result flag exists and is true)
      const aiHasRun = patient.AI_result === true;
      
      // If AI hasn't been run, show "-"
      if (!aiHasRun) {
        return "-";
      }
      
      // AI has been run, now check for AI_Report
      // Check if patient has Version 03 with uploads structure
      if (patient.Version === "03" && patient.uploads) {
        // Find the latest scan
        const scanKeys = Object.keys(patient.uploads)
          .filter((key) => key.toLowerCase().includes("scan"))
          .map((key) => ({
            key,
            number: parseInt(key.replace(/\D/g, "")) || 0,
          }))
          .sort((a, b) => b.number - a.number);

        if (scanKeys.length > 0) {
          const latestScanKey = scanKeys[0].key;
          const latestScan = patient.uploads[latestScanKey];
          
          // Check if AI_Report exists in the latest scan
          if (latestScan && latestScan.AI_Report && latestScan.AI_Report.classification) {
            return latestScan.AI_Report.classification;
          }
        }
      } else {
        // For legacy patients, check AI_Report at patient level
        if (patient.AI_Report && patient.AI_Report.classification) {
          return patient.AI_Report.classification;
        }
      }
      
      // AI has run but no AI_Report found
      return "NA";
    } catch (error) {
      console.error("Error getting AI classification:", error);
      return "NA";
    }
  };

  const getLatestStudyType = (patient) => {
    if (!patient) return "N/A";
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.startsWith("Scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan ", ""), 10),
        }))
        .sort((a, b) => b.number - a.number);

      for (const { key } of scanKeys) {
        const scan = patient.uploads[key];
        if (
          scan.Type_of_Data &&
          scan.Type_of_Data.trim() !== "" &&
          scan.Type_of_Data.toLowerCase() !== "na"
        ) {
          return scan.Type_of_Data.trim();
        }
        if (
          scan.Type_of_Dicom_Data &&
          scan.Type_of_Dicom_Data.trim() !== "" &&
          scan.Type_of_Dicom_Data.toLowerCase() !== "na"
        ) {
          return scan.Type_of_Dicom_Data.trim();
        }
        if (
          scan.Type_of_CT &&
          scan.Type_of_CT.trim() !== "" &&
          scan.Type_of_CT.toLowerCase() !== "na"
        ) {
          return scan.Type_of_CT.trim();
        }
      }
    }
    if (
      patient.Type_of_Data &&
      patient.Type_of_Data.trim() !== "" &&
      patient.Type_of_Data.toLowerCase() !== "na"
    ) {
      return patient.Type_of_Data.trim();
    }
    if (
      patient.Type_of_Dicom_Data &&
      patient.Type_of_Dicom_Data.trim() !== "" &&
      patient.Type_of_Dicom_Data.toLowerCase() !== "na"
    ) {
      return patient.Type_of_Dicom_Data.trim();
    }
    if (
      patient.Type_of_CT &&
      patient.Type_of_CT.trim() !== "" &&
      patient.Type_of_CT.toLowerCase() !== "na"
    ) {
      return patient.Type_of_CT.trim();
    }
    return "N/A";
  };

  const hasDicomFolder = (patient) => {
    let folderPath;
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().startsWith("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan", "").trim(), 10),
        }))
        .sort((a, b) => b.number - a.number);

      for (const { key } of scanKeys) {
        const scan = patient.uploads[key];
        if (scan && scan.FolderPath) {
          folderPath = getDecryptedFilePath(scan.FolderPath);
          break;
        }
      }
    } else {
      folderPath = getDecryptedFilePath(patient.FolderPath);
    }
    return Boolean(folderPath);
  };

  const handleScan = (id) => {
    const patient = posts[id];
     // deepa fix issue patient delete - guard against null patient object
    if(!patient) { 
      return null
    } 
    if (!patient) {
      toast.error("Patient data not found.", { position: "top-center" });
      return;
    }
    let folderPath;
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().startsWith("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan", "").trim(), 10),
        }))
        .sort((a, b) => b.number - a.number);

      for (const { key } of scanKeys) {
        const scanData = patient.uploads[key];
        if (scanData && scanData.FolderPath && scanData.FolderPath !== "NA") {
          folderPath = getDecryptedFilePath(scanData.FolderPath);
          break;
        }
      }
    } else {
      folderPath = getDecryptedFilePath(patient.FolderPath);
    }
    if (folderPath) {
      const viewerURL = `https://tryon.easiofy.com/DWV/?Patient=${folderPath}&View=Technician`;
      window.open(viewerURL, "_blank");
    } else {
      toast.error("Scan not available.", { position: "top-center" });
    }
  };

  //deepaaudit logs - Handle report download with audit logging
  const handleReport = async (encryptedReportURL, patientId) => {
    try {
      const decryptedReportURL = decrypt(encryptedReportURL);
      if (decryptedReportURL) {
        window.open(decryptedReportURL, "_blank");
        
        //deepaaudit logs - Get patient details and log successful download
        const patient = posts[patientId];
        await logDownloadReportAdmin({
          adminName: adminName1,
          patientId: patient?.ID || encrypt(patientId),
          patientName: patient?.FullName || "Unknown",
          reportUrl: decryptedReportURL,
          success: true
        });
      } else {
        alert("Report not available.");
        
        //deepaaudit logs - Log failed download attempt
        const patient = posts[patientId];
        await logDownloadReportAdmin({
          adminName: adminName1,
          patientId: patient?.ID || encrypt(patientId),
          patientName: patient?.FullName || "Unknown",
          reportUrl: encryptedReportURL,
          success: false,
          failureReason: "Report URL could not be decrypted"
        });
      }
    } catch (error) {
      console.error("Error handling report download:", error);
      alert("Error downloading report.");

      //deepaaudit logs - Log error in download
      const patient = posts[patientId];
      await logDownloadReportAdmin({
        adminName: adminName1,
        patientId: patient?.ID || encrypt(patientId),
        patientName: patient?.FullName || "Unknown",
        reportUrl: encryptedReportURL,
        success: false,
        failureReason: error.message || "Unknown error during download"
      });
    }
  };

  const handleGeneratedPatientDataClick = (patientId) => {
    const encryptedAdminName = window.btoa(adminName1);
    const encryptedPatientId = window.btoa(patientId);
    window.open(
      `/patient/${encryptedAdminName}/${encryptedPatientId}`,
      "_blank"
    );
  };

  const getLatestPrescriptionURL = (patient) => {
    if (!patient) {
      return null;
    }

    let foundPrescriptionURL = "";
    let prescriptionSource = "";
    const patientId = patient.ID || "Unknown";    
    // PRIORITY 1: Find prescription in uploads (Version 03 patients) - Check LATEST scan first
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().includes("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace(/\D/g, "")) || 0,
        }))
        .sort((a, b) => b.number - a.number); // Sort by highest number first (latest scan)
      
      for (const { key } of scanKeys) {
        const scanData = patient.uploads[key];
        if (!scanData) continue;
                
        // Check for encrypted PrescriptionURL first, then plain text
        const prescription = getPatientData(scanData, "PrescriptionURL") || scanData.PrescriptionURL;
        
        if (prescription) {
          // Handle array of prescriptions (get the latest one)
          if (Array.isArray(prescription) && prescription.length > 0) {
            const latestPrescription = prescription[prescription.length - 1];
            if (latestPrescription && latestPrescription.trim() !== "" && 
                latestPrescription !== "NA" && latestPrescription !== "Not Uploaded") {
              foundPrescriptionURL = latestPrescription;
              prescriptionSource = `Latest Upload (${key})`;
              break;
            }
          }
          // Handle single prescription string
          else if (typeof prescription === "string" && prescription.trim() !== "" && 
                   prescription !== "NA" && prescription !== "Not Uploaded") {
            foundPrescriptionURL = prescription;
            prescriptionSource = `Latest Upload (${key})`;
            break;
          }
        }
      }
    }
    
    // PRIORITY 2: Fallback to main patient node for prescription (both Version 03 and legacy)
    if (!foundPrescriptionURL) {      
      // Try encrypted field first, then plain text field
      const mainPrescriptionURL = getPatientData(patient, "PrescriptionURL") || patient.PrescriptionURL;      
      if (mainPrescriptionURL) {
        // Handle array of prescriptions (get the latest one)
        if (Array.isArray(mainPrescriptionURL) && mainPrescriptionURL.length > 0) {
          const latestPrescription = mainPrescriptionURL[mainPrescriptionURL.length - 1];
          if (latestPrescription && latestPrescription.trim() !== "" && 
              latestPrescription !== "NA" && latestPrescription !== "Not Uploaded") {
            foundPrescriptionURL = latestPrescription;
            prescriptionSource = "Main Patient Node";
          }
        }
        // Handle single prescription string
        else if (typeof mainPrescriptionURL === "string" && mainPrescriptionURL.trim() !== "" && 
                 mainPrescriptionURL !== "NA" && mainPrescriptionURL !== "Not Uploaded") {
          foundPrescriptionURL = mainPrescriptionURL;
          prescriptionSource = "Main Patient Node";
        }
      }
    }
    
    // PRIORITY 3: No prescription found anywhere
    if (!foundPrescriptionURL) {
      prescriptionSource = "Not Available";
    }
  
    return foundPrescriptionURL || null;
  };

  const handleClinicalHistoryClick = (patientId, patient) => {
    const clinicalTextFromDB = patient.Clinical_Textarea || "";
    const clinicalFileFromDB = patient.Clinical_Filepath || "";

    if (!clinicalTextFromDB && !clinicalFileFromDB) {
      toast.info("Clinical History Not Available", { position: "top-center" });
      return;
    }

    const decryptedFilePath = getDecryptedFilePath(clinicalFileFromDB);
    setSelectedPatientId(patientId);
    setClinicalHistoryText(clinicalTextFromDB);
    setAttachedFile(decryptedFilePath ? { name: decryptedFilePath } : null);
    setClinicalHistoryModalVisible(true);
  };
// Viniith + Deepa: Delete patient + files, with Audit Logging + State Update
const handleDeletePatient = async (patientId) => {
  try {
    // Get patient data to access the patient name for confirmation
    const patient = posts[patientId];
    const patientName = patient?.FullName || "this patient";
    const encryptedPatientId = patient?.ID || encrypt(patientId);

    // Confirmation with patient name
    if (
      window.confirm(
        `Are you sure you want to delete ${patientName}? This will permanently delete all files and data for this patient.`
      )
    ) {
      // Initialize Firebase Storage
      const storage = getStorage();

      // Define the patient's storage path
      const patientStoragePath = `superadmin/admins/${adminName1}/patients/${patientId}`;

      // Function to recursively delete all files and folders in patient's storage
      const deletePatientFiles = async (path) => {
        try {
          const folderRef = storageRef(storage, path);
          const { prefixes, items } = await listAll(folderRef);

          // Delete all files in current folder
          const deletePromises = items.map((fileRef) => deleteObject(fileRef));
          await Promise.all(deletePromises);

          // Recursively delete all subfolders
          const subfolderPromises = prefixes.map((prefixRef) =>
            deletePatientFiles(prefixRef.fullPath)
          );
          await Promise.all(subfolderPromises);
        } catch (error) {
          // If folder doesn't exist or is empty, that's okay
          if (error.code !== "storage/object-not-found") {
            console.warn(
              `Warning: Could not delete files from ${path}:`,
              error.message
            );
          }
        }
      };

      // Delete all patient files from Firebase Storage
      await deletePatientFiles(patientStoragePath);

      // Delete the patient node from Firebase Realtime Database
      const patientRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}`
      );
      await set(patientRef, null);

      // Update local state to remove patient from UI
      setPosts((prevPosts) => {
        const updatedPosts = { ...prevPosts };
        delete updatedPosts[patientId];
        return updatedPosts;
      });

      // ✅ Audit Log - success
      await logDeletePatientAdmin({
        adminName: adminName1,
        patientId: encryptedPatientId,
        patientName: patientName,
        success: true,
      });

      toast.success(
        `Patient ${patientName} and all associated files deleted successfully!`,
        {
          position: "top-center",
        }
      );
    }
  } catch (error) {
    console.error("Error deleting patient:", error);
    toast.error("Failed to delete patient. Please try again.", {
      position: "top-center",
    });

    // ✅ Audit Log - failure
    const patient = posts[patientId];
    await logDeletePatientAdmin({
      adminName: adminName1,
      patientId: patient?.ID || encrypt(patientId),
      patientName: patient?.FullName || "Unknown",
      success: false,
      failureReason: error.message || "Failed to delete patient",
    });
  }
};

  // Handler to toggle patient priority status
  const handleTogglePriority = async (patientId, currentPriorityStatus) => {
    try {
      // Check if report is finalized - prevent priority changes for finalized reports
      const patient = posts[patientId];
      if (patient && patient.Report_Status === "Final") {
        toast.warning("Cannot change priority - Report is already finalized", {
          position: "top-center",
        });
        return;
      }

      const newPriorityStatus = !currentPriorityStatus;
      const patientRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}/isPriority`
      );

      await set(patientRef, newPriorityStatus);

      // Update local state
      setPosts((prevPosts) => ({
        ...prevPosts,
        [patientId]: {
          ...prevPosts[patientId],
          isPriority: newPriorityStatus,
        },
      }));

      toast.success(
        newPriorityStatus ? "Patient marked as Priority" : "Priority removed",
        { position: "top-center" }
      );
    } catch (error) {
      console.error("Error updating priority status:", error);
      toast.error("Failed to update priority status", {
        position: "top-center",
      });
    }
  };

  const handleAssignDoctor = async (
    patientId,
    selectedDoctor,
    isAssigned,
    isBulkAssign = false
  ) => {
    try {
      const doctorField = "DoctorAssigned";
      const valuesRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}/${doctorField}`
      );

      if (isAssigned) {
        //deepaforaudit logs - Get current doctors before unassigning - ensure unique names using Set
        const currentDoctors = posts[patientId]?.[doctorField] || [];
        const previousDoctorsList = [...new Set(currentDoctors.map(doc => 
          typeof doc === "string" ? doc : doc.name
        ))];

        // unassign
        runTransaction(valuesRef, (currentData) => {
          if (currentData) {
            const updatedData = currentData.filter(
              (doctor) => {
                // Handle both string and object formats
                if (typeof doctor === "string") {
                  return doctor !== selectedDoctor;
                } else {
                  return doctor.name !== selectedDoctor;
                }
              }
            );
            return updatedData.length > 0 ? updatedData : null;
          }
          return null;
        });
        setPosts((prevPosts) => ({
          ...prevPosts,
          [patientId]: {
            ...prevPosts[patientId],
            [doctorField]: (prevPosts[patientId][doctorField] || []).filter(
              (doctor) => {
                // Handle both string and object formats
                if (typeof doctor === "string") {
                  return doctor !== selectedDoctor;
                } else {
                  return doctor.name !== selectedDoctor;
                }
              }
            ),
          },
        }));
        if (!isBulkAssign) {
          toast.success("Doctor Unassigned Successfully", {
            position: "top-center",
          });

          //deepaforaudit logs - Log individual unassignment
          await logIndividualAssignmentAdmin({
            assignedBy: adminName1,
            assignedDoctor: selectedDoctor,
            patientId: patientId,
            patientName: posts[patientId]?.FullName || "Unknown",
            success: true,
            assignmentType: "unassign"
          });
        }
      } else {
        //deepaforaudit logs - Get current doctors before assigning - ensure unique names using Set
        const currentDoctors = posts[patientId]?.[doctorField] || [];
        const previousDoctorsList = [...new Set(currentDoctors.map(doc => 
          typeof doc === "string" ? doc : doc.name
        ))];

        // assign
        const assignedAt = formatDate(new Date());
        const doctorWithTimestamp = { name: selectedDoctor, assignedAt };
        runTransaction(valuesRef, (currentData) => {
          if (currentData) {
            return [...currentData, doctorWithTimestamp];
          }
          return [doctorWithTimestamp];
        });
        setPosts((prevPosts) => ({
          ...prevPosts,
          [patientId]: {
            ...prevPosts[patientId],
            [doctorField]: [
              ...(prevPosts[patientId][doctorField] || []),
              doctorWithTimestamp,
            ],
          },
        }));
        if (!isBulkAssign) {
          toast.success("Doctor Assigned Successfully", {
            position: "top-center",
          });

          //deepaforaudit logs - Log individual assignment
          await logIndividualAssignmentAdmin({
            assignedBy: adminName1,
            assignedDoctor: selectedDoctor,
            patientId: patientId,
            patientName: posts[patientId]?.FullName || "Unknown",
            success: true,
            assignmentType: "assign"
          });
        }
      }
      setSelectedDropdownId(null);
    } catch (error) {
      alert("Error Assigning Doctor. " + error);

      //deepaforaudit logs - Log individual assignment failure if not bulk assign
      if (!isBulkAssign) {
        await logIndividualAssignmentAdmin({
          assignedBy: adminName1,
          assignedDoctor: selectedDoctor,
          patientId: patientId,
          patientName: posts[patientId]?.FullName || "Unknown",
          success: false,
          failureReason: error.message || "Unknown error during assignment",
          assignmentType: isAssigned ? "unassign" : "assign"
        });
      }
    }
  };

  //deepaaudit logs - Bulk Assign function with audit logging
  const handleBulkAssign = async () => {
    try {
      // audit Log bulk assignment start
      const patientIds = [];
      const patientNames = [];

      // Collect patient details before assignment
      bulkSelectedPatients.forEach((patientId) => {
        const patient = posts[patientId];
        const patientName = patient?.FullName || "Unknown";
        const patientIdEncrypted = patient?.ID || patientId;

        patientIds.push(patientIdEncrypted);
        patientNames.push(patientName);
      });

      await logBulkAssignmentAdmin({
        assignedBy: adminName1,
        assignedDoctor: bulkSelectedDoctor,
        patientCount: bulkSelectedPatients.length,
        patientIds: patientIds,
        patientNames: patientNames,
        success: true,
        assignmentType: "bulk"
      });

      // Execute bulk assignments
      const assignmentPromises = bulkSelectedPatients.map((patientId) =>
        handleAssignDoctor(patientId, bulkSelectedDoctor, false, true)
      );

      await Promise.all(assignmentPromises);

      toast.success("Doctor assigned successfully!", { position: "top-center" });
      setBulkAssignModalVisible(false);
      setBulkSelectedPatients([]);
      setBulkSelectedDoctor("");
    } catch (error) {
      console.error("Bulk assignment error:", error);
      // Log bulk assignment failure
      const patientIds = bulkSelectedPatients.map((patientId) => {
        const patient = posts[patientId];
        return patient?.ID || patientId;
      });

      const patientNames = bulkSelectedPatients.map((patientId) => {
        const patient = posts[patientId];
        return patient?.FullName || "Unknown";
      });

      await logBulkAssignmentAdmin({
        assignedBy: adminName1,
        assignedDoctor: bulkSelectedDoctor,
        patientCount: bulkSelectedPatients.length,
        patientIds: patientIds,
        patientNames: patientNames,
        success: false,
        failureReason: error.message || "Unknown error during bulk assignment",
        assignmentType: "bulk"
      });

      toast.error("Bulk assignment failed. Please try again.", {
        position: "top-center",
      });
    }
  };

  const handleExportClick = () => {
    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates.", {
        position: "top-center",
      });
    } else {
      exportCSV(startDate, endDate);
      setIsModalOpen(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setStartDate(null);
    setEndDate(null);
  };

  //deepaaudit logs - Export data with audit logging
  const exportCSV = async (startDate, endDate) => {
    try {
      if (!startDate || !endDate) {
        alert("Please select both start and end dates");
        return;
      }
      const adjustedEndDate = new Date(endDate);
      adjustedEndDate.setHours(23, 59, 59, 999);

      const csvRows = [];
      const headers = [
        `"Patient Name"`,
        `"DOB"`,
        `"Modality"`,
        `"Study Receiving Date"`,
        `"Clinical Timestamp"`,
        `"Patient Timestamp"`,
        `"Added By"`,
        `"Reported By"`,
      ];
      csvRows.push(headers.join(","));

      let exportedRecords = 0;
      Object.keys(posts).forEach((id) => {
        const patient = posts[id];
                      // deepa fix issue patient delete - guard against null patient object
                      if (!patient) {
                        return null;
                      }
        const timestampStr = patient.Timestamp || "";
        if (!timestampStr) return;
        const patientDate = parseTimestamp(timestampStr);
        if (isNaN(patientDate)) return;

        if (patientDate >= startDate && patientDate <= adjustedEndDate) {
          const row = [
            `"${patient.FullName || ""}"`,
            `"${patient.DOB || "NA"}"`,
            `"${patient.Modality || "NA"}"`,
            `"${patient.StudyDate || "NA"}"`,
            `"${patient.Clinical_Timestamp || "NA"}"`,
            `"${patient.Timestamp || "NA"}"`,
            `"${patient.Addedby || "NA"}"`,
            `"${patient.Report_Addedby || "NA"}"`,
          ];
          csvRows.push(row.join(","));
          exportedRecords++;
        }
      });

      if (csvRows.length === 1) {
        const errorMsg = "No patients found in the selected date range";
        toast.error(errorMsg, {
          position: "top-center",
        });

        //deepaaudit logs - Log failed export due to no data
        await logExportDataAdmin({
          adminName: adminName1,
          startDate: startDate.toISOString().split('T')[0],
          endDate: endDate.toISOString().split('T')[0],
          exportType: "csv",
          recordCount: 0,
          success: false,
          failureReason: errorMsg
        });
        return;
      }

      const csvString = csvRows.join("\n");
      const blob = new Blob([csvString], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Patients.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      //deepaaudit logs - Log successful export
      await logExportDataAdmin({
        adminName: adminName1,
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
        exportType: "csv",
        recordCount: exportedRecords,
        success: true
      });
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export data. Please try again.", {
        position: "top-center",
      });

      //deepaaudit logs - Log failed export
      await logExportDataAdmin({
        adminName: adminName1,
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
        exportType: "csv",
        recordCount: 0,
        success: false,
        failureReason: error.message || "Failed to export data"
      });
    }
  };

  const toggleDropdown = (id) => {
    setSelectedDropdownId((prevId) => (prevId === id ? null : id));
  };

  // ============================
  // New AI Architecture Helpers
  // ============================

  // We keep track of tasks in `aiTasks`.
  // For each patient, we store { patientId, model, subModel, status }.

  // Common function to store postpaid AI usage
  const storePostpaidAIUsage = async (modelName, costValue, runBy, patientName, patientID, status = "Done") => {
    // Only exclude Prepaid costing type, log for all others (Cost Per Upload, Cost Per View, Cost Per Upload + View)
    if (costingType && costingType.toLowerCase() === "prepaid") {
      return;
    }
    try {
      const now = new Date();
      const months = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
      ];
      const currentMonth = months[now.getMonth()];
      const currentYear = now.getFullYear();
      const currentMonthYear = `${currentMonth} ${currentYear}`;
      const timestamp = now.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
      });
      const postpaidPath = `superadmin/admins/${adminName1}/Postpaid/${currentMonthYear}`;
      const postpaidRef = ref(db, postpaidPath);
      const snapshot = await get(postpaidRef);
      const nextIndex = snapshot.exists() ? Object.keys(snapshot.val()).length : 0;
      const usageDetails = {
        AIModelName: modelName,
        Price: String(costValue),
        RunBy: runBy,
        PatientName: encrypt(patientName),
        PatientID: encrypt(patientID),
        Timestamp: timestamp,
        Status: status
      };
      const usageRef = ref(db, `${postpaidPath}/${nextIndex}`);
      await set(usageRef, usageDetails);
    } catch (error) {
      console.error("Error storing postpaid AI usage:", error);
    }
  };

  // "Clear" a finished or failed task from the local list
  const handleClearTask = (index) => {
    setAiTasks((prev) => prev.filter((_, i) => i !== index));
  };

  // Called by the AIModelHandler: updates the "status" for a given patient in aiTasks
  const updateAiTask = (patientId, updates) => {
    setAiTasks((prev) => {
      const existingIndex = prev.findIndex((t) => t.patientId === patientId);
      if (existingIndex >= 0) {
        const newArr = [...prev];
        newArr[existingIndex] = { ...newArr[existingIndex], ...updates };
        return newArr;
      } else {
        return [...prev, { patientId, ...updates }];
      }
    });
  };

  // If we do a Prepaid flow, we might deduct from wallet. For example:
  const handleWalletDeduction = async (costKey, patient, triggeredByUser) => {
    if (!costKey) return; // No cost? No deduction
    let costValue = 0;
    if (costKey === "CXR-TB") {
      costValue = cxrTbCost;
    } else if (costKey === "CXR-TB2") {
      costValue = cxrTb2Cost;
    } else if (costKey === "CXR-Multiclass") {
      costValue = cxrMulticlassCost;
    } else if (costKey === "XRay-Fracture") {
      costValue = xrayFractureCost;
    } else if (costKey === "3D-Abdomen") {
      costValue = threeDAbdomenCost;
    } else if (costKey === "Tumor-Abdomen") {
      costValue = tumorAbdomenCost;
    } else if (costKey === "Contour-Abdomen") {
      costValue = contourAbdomenCost;
    } else if (costKey === "Contour-HaN") {
      costValue = contourHaNModelCost;
    } else if (costKey === "Liver-Segmentation") {
      costValue = liverSegmentationCost;
    } else {
      costValue = 0; // fallback
    }

    // Check cost
    if (costingType.toLowerCase() === "prepaid") {
      if (walletBalance < costValue) {
        // In your original code, you might show a confirm or do a toast
        throw new Error("Insufficient funds");
      }
    }

    // If we get here, we either have enough funds (prepaid) or we are postpaid
    // Deduct if it's Prepaid
    if (costingType.toLowerCase() === "prepaid" && costValue > 0) {
      // runTransaction
      const walletRef = ref(
        db,
        `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
      );
      const { snapshot } = await runTransaction(walletRef, (currentBalance) => {
        if (currentBalance === null) return 0;
        return currentBalance - costValue;
      });
      const updatedBalance = snapshot.val() || 0;
      setWalletBalance(updatedBalance);

      // Store transaction
      const dateObj = new Date();
      const months = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      const month = months[dateObj.getMonth()];
      const year = dateObj.getFullYear();
      const currentMonthYear = `${month} ${year}`;

      const walletTxPath = `superadmin/admins/${adminName1}/Wallet/Wallet_Transactions/${currentMonthYear}`;
      const txSnapshot = await get(ref(db, walletTxPath));
      const nextIndex = txSnapshot.exists()
        ? Object.keys(txSnapshot.val()).length
        : 0;

      const transaction = {
        ModelRunby: triggeredByUser,
        PatientName: patient.FullName || "Unknown",
        PatientID: patient.ID || "Unknown",
        AIModel: costKey, // e.g. "boneFractureCost" or "contouringModelCost"
        AmountDeducted: costValue,
        UpdatedBalance: updatedBalance,
        Timestamp: new Date().toLocaleString("en-GB"),
      };
      await set(ref(db, `${walletTxPath}/${nextIndex}`), transaction);
    }
  };

  // If we want to store "AI_result" or set FolderPath, do it here:
  const markAIResult = async (patientId, newFolderPath = null) => {
    // 1) Mark /AI_result = true
    const aiResultRef = ref(
      db,
      `superadmin/admins/${adminName1}/patients/${patientId}/AI_result`
    );
    await set(aiResultRef, true);

    // 2) Optionally update the FolderPath if "newFolderPath" is provided
    if (newFolderPath) {
      const encryptedFolderPath = encrypt(newFolderPath);

      // If you have logic to figure out which "ScanKey" to update for Version=03
      // then you'd do it. Otherwise, if it's single folder path:
      const folderPathRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}/FolderPath`
      );
      await set(folderPathRef, encryptedFolderPath);
    }
  };

  // A function that, given the model ID, executes the pipeline
  async function executeAIModel({
    patientId,
    modelId,
    modelDisplayName,
  }) {
    const patient = posts[patientId];
    if (!patient) {
      toast.error("Patient data not found", { position: "top-center" });
      return;
    }
    if (patient.AI_result) {
      updateAiTask(patientId, { status: "Already done" });
      toast.info(`AI already run for this patient`, { position: "top-center" });
      return;
    }
    let costValue = 0;
    if (modelId === "XRAY_FRACTURE") {
      costValue = xrayFractureCost; // from your local React state
    } else if (modelId === "CONTOUR_ABDOMEN") {
      costValue = contourAbdomenCost; // from your local React state
            } else if (modelId === "Contour-HaN") {
          costValue = contourHaNModelCost; // from your local React state
    } else if (modelId === "THREED_ABDOMEN") {
      costValue = threeDAbdomenCost; // from your local React state
    } else if (modelId === "TUMOR_ABDOMEN") {
      costValue = tumorAbdomenCost; // from your local React state
    } else if (modelId === "CXR_TB") {
      costValue = cxrTbCost; // from your local React state
    } else if (modelId === "CXR_TB2") {
      costValue = cxrTb2Cost; // from your local React state
    } else if (modelId === "CXR_MULTICLASS") {
      costValue = cxrMulticlassCost; // from your local React state
    } else if (modelId === "LIVER_SEGMENTATION") {
      costValue = liverSegmentationCost; // from your local React state
    }
    if (
      costingType &&
      costingType.toLowerCase() === "prepaid" &&
      costValue > 0 &&
      walletBalance < costValue
    ) {
      setInsufficientBalanceModal({ open: true, patientId });
      updateAiTask(patientId, { status: "Insufficient funds" });
      return;
    }
    const aiHandler = new AIModelHandler({
      modelId,
      adminName: adminName1,
      updateTask: (pid, obj) => updateAiTask(pid, obj),
      markAIResult: async (pid, folderPath) => {
        await markAIResult(pid, folderPath);
      },
      getDecryptedFolderPath: (pat) => {
        let folderPath = "";
        if (pat.Version === "03" && pat.uploads) {
          const scanKeys = Object.keys(pat.uploads)
            .filter((key) => key.toLowerCase().startsWith("scan"))
            .map((key) => ({
              key,
              number: parseInt(key.replace("Scan", "").trim(), 10),
            }))
            .sort((a, b) => b.number - a.number);
          for (const { key } of scanKeys) {
            const scanData = pat.uploads[key];
            if (
              scanData &&
              scanData.FolderPath &&
              scanData.FolderPath !== "NA"
            ) {
              folderPath = getDecryptedFilePath(scanData.FolderPath);
              break;
            }
          }
        } else {
          folderPath = getDecryptedFilePath(pat.FolderPath);
        }
        return folderPath;
      },
      toast,
      costingType,
      handleWalletDeduction,
      triggeredByUser: adminName1,
    });
    try {
      updateAiTask(patientId, {
        status: "Starting",
        model: modelId,
      });
      setAiProcessingModalOpen(true); // open the tasks modal
      await aiHandler.runModel(patientId, patient, {
        costValue,
        walletBalance,
        costingType,
      });
      
      // Log usage for all costing types except Prepaid
      if (costingType && costingType.toLowerCase() !== "prepaid") {
        await storePostpaidAIUsage(
          modelDisplayName || modelId,
          costValue,
          adminName1,
          patient.FullName || "Unknown",
          patient.ID || "Unknown",
          "Done"
        );
      }
    } catch (err) {
      console.error(`${modelDisplayName} model error:`, err);
      if (costingType && costingType.toLowerCase() !== "prepaid") {
        await storePostpaidAIUsage(
          modelDisplayName || modelId,
          0,
          adminName1,
          patient.FullName || "Unknown",
          patient.ID || "Unknown",
          "Fail"
        );
      }
      if (err.message && err.message.includes("Insufficient funds")) {
        updateAiTask(patientId, { status: "Insufficient funds" });
        toast.error(
          `Not enough balance to run ${modelDisplayName || modelId}`,
          {
            position: "top-center",
          }
        );
      } else {
        updateAiTask(patientId, { status: "Failed" });
        toast.error(`${modelDisplayName} model failed`, {
          position: "top-center",
        });
      }
    }
  }

  // -----------
  //  The UI
  // -----------

  // AI Button opens the model selection modal
  const handleAI = (patientId) => {
    setAiModalPatientId(patientId);
    setAiModalVisible(true);
  };

  const confirmBoneFracture = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run XRay Fracture Detection on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "XRAY_FRACTURE",
        modelDisplayName: "XRay-Fracture",
      });
    }
  };

  const confirmContouringAbdomen = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Contour-Abdomen on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "CONTOUR_ABDOMEN",
        modelDisplayName: "Contour-Abdomen",
      });
    }
  };

  const confirmAbdomenTumorAnalysis = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Tumor-Abdomen Analysis on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "TUMOR_ABDOMEN",
        modelDisplayName: "Tumor-Abdomen",
      });
    }
  };

  const confirmTBDetection = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-TB Detection on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "CXR_TB",
        modelDisplayName: "CXR-TB",
      });
    }
  };

  const confirmTB2Detection = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-TB2 Detection on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "CXR_TB2",
        modelDisplayName: "CXR-TB2",
      });
    }
  };

  const confirm3DAbdomen = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run 3D-Abdomen generation on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "THREED_ABDOMEN",
        modelDisplayName: "3D-Abdomen",
      });
    }
  };

  const confirmContourHaN = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Contour-HaN generation on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "Contour-HaN",
        modelDisplayName: "Contour-HaN",
      });
    }
  };

  const showAIButton = (patient) => {
    const mod = (getLatestModality(patient) || "").toLowerCase();
    if (mod.includes("ct")) return true;
    if (mod.includes("xr") || mod.includes("x ray") || mod.includes("x-ray")) {
      return true;
    }
    if (mod.includes("mri") || mod.includes("mr")) return true;
    return false;
  };

  // returns enabled models for the given modality
  const getEnabledModels = (patient) => {
    const mod = (getLatestModality(patient) || "").toLowerCase();
    const results = {
      xrayFracture: false,
      cxrTb: false,
      cxrMulticlass: false,
      contourAbdomen: false,
      tumorAbdomen: false,
      threeDAbdomen: false,
      liverSegmentation: false,
      contourHaN: false, // Add this line
    };
  
    // X-ray modalities
    if (
      mod.includes("xray") ||
      mod.includes("x-ray") ||
      mod.includes("xr") ||
      mod.includes("x ray")
    ) {
      results.xrayFracture = aiModelsEnabled["XRay-Fracture"] === true;
      results.cxrTb = aiModelsEnabled["CXR-TB"] === true;
      results.cxrTb2 = aiModelsEnabled["CXR-TB2"] === true;
      results.cxrMulticlass = aiModelsEnabled["CXR-Multiclass"] === true;
    }
  
    // CT modalities
    if (mod.includes("ct")) {
      results.contourAbdomen = aiModelsEnabled["Contour-Abdomen"] === true;
      results.tumorAbdomen = aiModelsEnabled["Tumor-Abdomen"] === true;
      results.threeDAbdomen = aiModelsEnabled["3D-Abdomen"] === true;
      results.liverSegmentation = aiModelsEnabled["Liver-Segmentation"] === true;
      results.contourHaN = aiModelsEnabled["Contour-HaN"] === true;
    }
  
    return results;
  };

  const handleResetAI = async (patientId) => {
    // 1) confirm
    if (
      !window.confirm(
        "Are you sure you want to reset AI results for this patient?"
      )
    )
      return;

    const patient = posts[patientId];
    if (!patient?.AI_result) return;

    // 2) decrypt folderPath once
    const folderPath = getDecryptedFilePath(
      patient.Version === "03" && patient.uploads
        ? Object.values(patient.uploads).find(
            (s) => s.FolderPath && s.FolderPath !== "NA"
          )?.FolderPath
        : patient.FolderPath
    );
    if (!folderPath) {
      toast.error("No storage folder found", { position: "top-center" });
      return;
    }

    const storage = getStorage();
    const mod = getLatestModality(patient).toLowerCase();

    try {
      if (mod.includes("ct")) {
        // —— Contouring model reset ——
        // Recursively walk `folderPath`, deleting only dicom-seg-[1–9].dcm files
        const deleteSegRecursively = async (currentPath) => {
          // Get a reference to the folder
          const folderRef = storageRef(storage, currentPath);
          const { prefixes, items } = await listAll(folderRef);

          // 1) delete any files named dicom-seg-[1–9].dcm
          const segFiles = items.filter((fileRef) =>
            /^dicom\-seg\-[1-9]\.dcm$/.test(fileRef.name)
          );
          await Promise.all(segFiles.map((fileRef) => deleteObject(fileRef)));

          // 2) recurse into sub-folders
          await Promise.all(
            prefixes.map((prefRef) => deleteSegRecursively(prefRef.fullPath))
          );
        };

        // start recursion at the root folderPath
        await deleteSegRecursively(folderPath);

        // Also remove 3D GLB files for CT scans
        const folderRef = storageRef(storage, folderPath);
        const { items } = await listAll(folderRef);
        const threeDFiles = items.filter((fileRef) =>
          fileRef.name.toLowerCase().endsWith('.glb')
        );
        if (threeDFiles.length > 0) {
          await Promise.all(threeDFiles.map((fileRef) => deleteObject(fileRef)));
        }

        // Also check patient root directory for GLB files (where 3D-Abdomen saves them)
        const patientRootPath = `superadmin/admins/${adminName1}/patients/${patientId}`;
        const patientRootRef = storageRef(storage, patientRootPath);
        try {
          const { items: rootItems } = await listAll(patientRootRef);
          const rootThreeDFiles = rootItems.filter((fileRef) =>
            fileRef.name.toLowerCase().endsWith('.glb')
          );
          if (rootThreeDFiles.length > 0) {
            await Promise.all(rootThreeDFiles.map((fileRef) => deleteObject(fileRef)));
          }
        } catch (error) {
          console.log("No GLB files found in patient root directory or error accessing it:", error.message);
        }

        // Clear 3D file references in Realtime DB for CT scans
        const patientDbRef = ref(db, `superadmin/admins/${adminName1}/patients/${patientId}`);
        const patientSnapshot = await get(patientDbRef);
        const patientData = patientSnapshot.val();

        if (patientData && patientData.Version === "03" && patientData.uploads) {
          // For Version 03 patients with uploads structure
          const uploads = patientData.uploads;
          const scanKeys = Object.keys(uploads).filter((key) => key.toLowerCase().startsWith("scan"));
          
          // Clear 3D data from all scans
          for (const scanKey of scanKeys) {
            const scanPath3DRef = ref(db, `superadmin/admins/${adminName1}/patients/${patientId}/uploads/${scanKey}/Path3D`);
            const scanDicom3DURLRef = ref(db, `superadmin/admins/${adminName1}/patients/${patientId}/uploads/${scanKey}/Dicom_3DURL`);
            
            await Promise.all([
              set(scanPath3DRef, ""),
              set(scanDicom3DURLRef, "")
            ]);
          }
        } else {
          // For legacy patients, clear patient level 3D data
          const path3DRef = ref(db, `superadmin/admins/${adminName1}/patients/${patientId}/Path3D`);
          const dicom3DURLRef = ref(db, `superadmin/admins/${adminName1}/patients/${patientId}/Dicom_3DURL`);
          
          await Promise.all([
            set(path3DRef, ""),
            set(dicom3DURLRef, "")
          ]);
        }

        toast.success("AI results have been reset", { position: "top-center" });
      } else {
        // —— Bone‐Fracture & TB model reset ——
        const aiResultsRef = storageRef(storage, `${folderPath}/AI_Results`);
        const { prefixes, items } = await listAll(aiResultsRef);
        // delete files in AI_Results
        await Promise.all(items.map((it) => deleteObject(it)));
        // delete any nested folders under AI_Results
        for (const prefixRef of prefixes) {
          const nested = await listAll(prefixRef);
          await Promise.all(nested.items.map((it) => deleteObject(it)));
        }
        toast.success("AI results have been reset", { position: "top-center" });
      }

      // Clean up AI_Report data from Firebase Realtime Database using AIModelHandler
      await AIModelHandler.resetAIReport(patientId, adminName1);

      // 4) flip the flag in Realtime DB
      const dbPath = `superadmin/admins/${adminName1}/patients/${patientId}/AI_result`;
      await set(ref(db, dbPath), false);
    } catch (err) {
      console.error("Reset AI error:", err);
      toast.error("Failed to reset AI results", { position: "top-center" });
    }
  };

  // Add confirm handler for Liver-Segmentation
  const confirmLiverSegmentation = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Liver-Segmentation on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "LIVER_SEGMENTATION",
        modelDisplayName: "Liver-Segmentation",
      });
    }
  };

  const confirmCXRMulticlass = (patientId) => {
    const patient = posts[patientId];
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-Multiclass Analysis on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      executeAIModel({
        patientId,
        modelId: "CXR_MULTICLASS",
        modelDisplayName: "CXR-Multiclass",
      });
    }
  };

  return (
    <>
      {/* New Warning Message if any AI task is "in-progress" */}
      {aiTasks.length > 0 &&
        aiTasks.some(
          (task) =>
            ![
              "done",
              "already done",
              "failed",
              "server down",
              "insufficient funds",
            ].includes(task.status.toLowerCase())
        ) && (
          <div
            style={{
              position: "fixed",
              top: "70px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#fff3f3",
              padding: "12px 24px",
              border: "2px solid #ff4d4d",
              borderRadius: "8px",
              zIndex: 10000,
              fontWeight: "bold",
              fontSize: "16px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              textAlign: "center",
            }}
          >
            AI Processing in Progress – Do not close or refresh this page.
          </div>
        )}

      <div className="containeradmin-fluid" style={{ marginTop: "10%" }}>
        {/* Search Bars */}
        <div className="search-bar-containerAssignDoc">
          <Button
            onClick={() => navigate("/Admin/AddPatient")}
            className="bulk-assign-button"
          >
            Add Patient
          </Button>
          <Button
            onClick={() => setBulkAssignModalVisible(true)}
            className="bulk-assign-button"
          >
            Bulk Assign
          </Button>

          <div>
            <input
              type="text"
              placeholder="🔍 Patient ID"
              name="patientId"
              value={searchTerms.patientId}
              onChange={handleSearch}
              onFocus={(e) => e.target.placeholder = ""} // Viniith Fix this 05-08-2025 - Hide placeholder on focus
              onBlur={(e) => e.target.placeholder = "🔍 Patient ID"} // Viniith Fix this 05-08-2025 - Show placeholder on blur
              className="search-input"
            />
          </div>
          <div>
            <input
              type="text"
              placeholder="🔍 Name"
              name="fullName"
              value={searchTerms.fullName}
              onChange={handleSearch}
              onFocus={(e) => e.target.placeholder = ""} // Viniith Fix this 05-08-2025 - Hide placeholder on focus
              onBlur={(e) => e.target.placeholder = "🔍 Name"} // Viniith Fix this 05-08-2025 - Show placeholder on blur
              className="search-input"
            />
          </div>

          <div>
            <select
              name="modality"
              value={searchTerms.modality}
              onChange={handleSearch}
              className="search-select"
            >
              <option value="">🔍 Modality</option>
              <option value="na">NA</option>
              {[
                ...new Set(
                  Object.keys(posts).map((key) =>
                    (getLatestModality(posts[key]) || "n/a")
                      .trim()
                      .toLowerCase()
                  )
                ),
              ]
                .filter((mod) => mod !== "na" && ["xray"].includes(mod)) // Filter only XRAY
                .sort()
                .map((modality, index) => (
                  <option key={index} value={modality}>
                    {modality.toUpperCase()}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <select
              name="centerName"
              value={searchTerms.centerName}
              onChange={handleSearch}
              className="search-select"
            >
              <option value="">🔍 Center Name</option>
              {[
                ...new Set(
                  Object.keys(posts).map((key) => posts[key].Addedby || "")
                ),
              ]
                .filter((name) => name !== "")
                .map((centerName, index) => (
                  <option key={index} value={centerName}>
                    {centerName}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <select
              name="status"
              value={searchTerms.status}
              onChange={handleSearch}
              className="search-select"
            >
              <option value="">🔍 Status</option>
              <option value="read">Read</option>
              <option value="final">Final</option>
              <option value="pending">Pending</option>
            </select>
          </div>
          {/* Export Data Button - COMMENTED OUT */}
          {/* <Button
            onClick={() => setIsModalOpen(true)}
            className="bulk-assign-button"
          >
            Export Data
          </Button> */}
        </div>

        {/* Patients Table */}
        <div style={{ marginTop: "20px" }}>
          {/* Loading indicator for Firebase search */}
          {isSearchingFirebase && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px', padding: '10px', backgroundColor: '#f0f8ff', borderRadius: '5px' }}>
              <CircularProgress size={20} style={{ color: '#1976d2' }} />
              <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>Searching Patients...</span>
            </div>
          )}

          <div className="table-container">
            <table className="style-table ASSIGNDOCADMINPANELTABLE">
              <thead>
                <tr>
                  <th></th>
                  <th className="th-head T-NO" style={{ width: "80px" }}>
                    ID
                  </th>
                  <th className="th-head T-NAME" style={{ width: "100px" }}>
                    Name
                  </th>
                  <th>Age</th>
                  <th>Study</th>
                  <th style={{ width: "100px" }}>Modality</th>
                  <th>Study Date</th>
                  <th>Center Name</th>
                  <th>Received</th>
                  <th style={{ width: "200px" }}>Assigned Doctor</th>
                  <th style={{ width: "80px" }}>Assign Date</th>
                  <th style={{ width: "100px" }}>Report Date</th>
                  <th>Status</th>
                  {/* <th style={{ width: "120px" }}>AI Result</th> */}
                  <th style={{ width: "200px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentPatients.length > 0 ? (
                  currentPatients.map((id, index) => {
                    const patient = posts[id];
                     // deepa fix issue patient delete - guard against null patient object
                      if (!patient) {
                        return null;
                      }
                    const docAssigned = patient.DoctorAssigned || [];
                    const assignedDate =
                      docAssigned.length > 0 ? (() => {
                        // Find the latest assigned doctor (most recent assignedAt/timestamp)
                        const latestDoctor = docAssigned
                          .filter(doctor => typeof doctor === "object" && (doctor.assignedAt || doctor.timestamp))
                          .sort((a, b) => {
                            const dateA = new Date(a.assignedAt || a.timestamp);
                            const dateB = new Date(b.assignedAt || b.timestamp);
                            return dateB - dateA; // Sort descending (latest first)
                          })[0];
                        
                        if (latestDoctor) {
                          return latestDoctor.assignedAt || latestDoctor.timestamp;
                        }
                        return "NA";
                      })() : "NA";
                    const reportTimeStamp = patient.Report_TimeStamp || "NA";

                    const canShowAI = showAIButton(patient);
                    const { bone, contouring } = getEnabledModels(patient);

                    let foundReportURL = "";
                    let reportSource = ""; // Track where the report was found                  
                    // PRIORITY 1: Find report in uploads (Version 03 patients) - Check LATEST scan first
                    if (patient.Version === "03" && patient.uploads) {
                      const scanKeys = Object.keys(patient.uploads)
                        .filter((key) => key.toLowerCase().includes("scan"))
                        .map((key) => ({
                          key,
                          number: parseInt(key.replace(/\D/g, "")) || 0, // Extract number from scan key
                        }))
                        .sort((a, b) => b.number - a.number); // Sort by highest number first (latest scan)
                      for (const { key } of scanKeys) {
                        const upload = patient.uploads[key];                        
                        // Check for encrypted Dicom_ReportURL in uploads first, then plain text
                        const reportURL = getPatientData(upload, "Dicom_ReportURL") || upload.Dicom_ReportURL;
                        if (
                          reportURL &&
                          reportURL !== "NA" &&
                          reportURL !== "Not Uploaded" &&
                          reportURL.trim() !== ""
                        ) {
                          foundReportURL = reportURL;
                          reportSource = `Latest Upload (${key})`;
                          break; // Use the latest scan's report
                        }
                      }
                    }
                    
                    // PRIORITY 2: Fallback to main patient node for report (both Version 03 and legacy)
                    if (!foundReportURL) {
                      const mainReportURL = getPatientData(patient, "Dicom_ReportURL") || patient.Dicom_ReportURL;                      
                      if (
                        mainReportURL &&
                        mainReportURL !== "Not Uploaded" &&
                        mainReportURL !== "NA" &&
                        mainReportURL.trim() !== ""
                      ) {
                        foundReportURL = mainReportURL;
                        reportSource = "Main Patient Node";
                      }
                    }
                    
                    // PRIORITY 3: No report found anywhere
                    if (!foundReportURL) {
                      reportSource = "Not Available";
                    }
                  
                    return (
                      <tr key={index}>
                        <td>
                          <Tooltip title="Clinical History" arrow>
                            <HistoryIcon
                              style={{
                                cursor:
                                  patient.Clinical_Textarea ||
                                  patient.Clinical_Filepath
                                    ? "pointer"
                                    : "not-allowed",
                                opacity:
                                  patient.Clinical_Textarea ||
                                  patient.Clinical_Filepath
                                    ? 1
                                    : 0.5,
                              }}
                              onClick={
                                patient.Clinical_Textarea ||
                                patient.Clinical_Filepath
                                  ? () =>
                                      handleClinicalHistoryClick(id, patient)
                                  : null
                              }
                            />
                          </Tooltip>
                        </td>
                        <td style={{ width: "80px" }}>
                          <p className="study-column-wrap">
                          {/* Viniith Added 04-08-2025 for #! */}
                          {patientIDLink(patient)}
                          </p>
                        </td>
                        <td
                          className="admin-nameAssignDoc NAME-AdminAssignDoc"
                          style={{ cursor: "pointer" }}
                        >
                         <p className="study-column-wrap">{patientFullNameLink(id, patient)}</p>
                        </td>
                        <td>{patient.Age && patient.Age !== "NaN" && String(patient.Age).toLowerCase() !== "nan" ? patient.Age : "NA"}</td>
                        <td><p className="study-column-wrap">{getLatestStudyType(patient)}</p></td>
                        <td style={{ width: "100px" }}>
                          {getLatestModality(patient)}
                        </td>
                        <td>
                          {(() => {
                            const sortingDate = getSortingDate(patient);
                            return sortingDate
                              ? sortingDate.toLocaleDateString("en-GB")
                              : "NA";
                          })()}
                        </td>
                        <td>{patient.Addedby || "NA"}</td>
                        <td>
                          {patient.Timestamp
                            ? (() => {
                                const formattedTimestamp = formatTimestampForDisplay(patient.Timestamp);
                                const [date, time] = formattedTimestamp.split(", ");
                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span>{date}</span>
                                    {time && <span>{time}</span>}
                                  </div>
                                );
                              })()
                            : "NA"}
                        </td>

                        {/* Assigned Doctor (DoctorAssigned) */}
                        <DropdownCell
                          id={id}
                          patient={patient}
                          doctors={doctors}
                          selectedDropdownId={selectedDropdownId}
                          toggleDropdown={toggleDropdown}
                          handleAssignDoctor={handleAssignDoctor}
                        />

                        <td>
                          {assignedDate && assignedDate !== "NA"
                            ? (() => {
                                const splitDateTime = (dt) => {
                                  if (!dt || typeof dt !== "string")
                                    return { date: dt || "NA", time: "" };
                                  if (dt.includes(", ")) {
                                    const [date, time] = dt.split(", ");
                                    return { date, time };
                                  }
                                  const lastSpace = dt.lastIndexOf(" ");
                                  if (lastSpace > 0) {
                                    return {
                                      date: dt.slice(0, lastSpace),
                                      time: dt.slice(lastSpace + 1),
                                    };
                                  }
                                  return { date: dt, time: "" };
                                };
                                
                                const { date, time } = splitDateTime(assignedDate);
                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span>{date}</span>
                                    {time && <span>{time}</span>}
                                  </div>
                                );
                              })()
                            : "NA"}
                        </td>
                        <td>
                          {reportTimeStamp && reportTimeStamp !== "NA"
                            ? (() => {
                                const [date, time] = reportTimeStamp.split(", ");
                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span>{date}</span>
                                    {time && <span>{time}</span>}
                                  </div>
                                );
                              })()
                            : "NA"}
                        </td>
                        <td>{patient.Report_Status || "NA"}</td>
                        {/* <td>
                          <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            textAlign: "center"
                          }}>
                            {getAIClassification(patient)}
                          </div>
                        </td> */}

                        <td>
                          <div className="action-icons">
                            {/* Report */}
                            {foundReportURL ? (
                              <>
                                <Tooltip title="Report" arrow>
                                  <VisibilityIcon
                                    onClick={async () => {
                                      try {
                                        const decryptedURL = decrypt(foundReportURL);
                                        if (decryptedURL) {
                                          window.open(decryptedURL, "_blank");
                                          
                                          //deepaaudit logs - Log successful report view
                                          await logViewReportAdmin({
                                            adminName: adminName1,
                                            patientId: patient?.ID || encrypt(id),
                                            patientName: patient?.FullName || "Unknown",
                                            reportUrl: decryptedURL,
                                            success: true
                                          });
                                        } else {
                                          const errorMsg = "Report not available";
                                          toast.info(errorMsg, {
                                            position: "top-center",
                                          });

                                          //deepaaudit logs - Log failed report view
                                          await logViewReportAdmin({
                                            adminName: adminName1,
                                            patientId: patient?.ID || encrypt(id),
                                            patientName: patient?.FullName || "Unknown",
                                            reportUrl: foundReportURL,
                                            success: false,
                                            failureReason: errorMsg
                                          });
                                        }
                                      } catch (error) {
                                        console.error("Error viewing report:", error);
                                        const errorMsg = "Error viewing report";
                                        toast.error(errorMsg, {
                                          position: "top-center",
                                        });

                                        //deepaaudit logs - Log error in report view
                                        await logViewReportAdmin({
                                          adminName: adminName1,
                                          patientId: patient?.ID || encrypt(databaseId),
                                          patientName: patient?.FullName || "Unknown",
                                          reportUrl: foundReportURL,
                                          success: false,
                                          failureReason: error.message || errorMsg
                                        });
                                      }
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                  />
                                </Tooltip>
                                <Tooltip title="Download Report" arrow>
                                  <DownloadIcon
                                    onClick={async (e) => {
                                      e.preventDefault();
                                      try {
                                        const decryptedURL =
                                          decrypt(foundReportURL);
                                        const response = await fetch(
                                          decryptedURL
                                        );
                                        const blob = await response.blob();
                                        const url =
                                          window.URL.createObjectURL(blob);
                                        const link =
                                          document.createElement("a");
                                        link.href = url;
                                        link.download = `${patient.FullName}_Report.pdf`;
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                        window.URL.revokeObjectURL(url);

                                        //deepaaudit logs - Log successful report download
                                        await logDownloadReportAdmin({
                                          adminName: adminName1,
                                          patientId: patient?.ID || encrypt(databaseId),
                                          patientName: patient?.FullName || "Unknown",
                                          reportUrl: decryptedURL,
                                          success: true
                                        });
                                      } catch (error) {
                                        console.error(
                                          "Failed to download the file",
                                          error
                                        );
                                        toast.error(
                                          "Failed to download the file",
                                          { position: "top-center" }
                                        );

                                        //deepaaudit logs - Log failed report download
                                        await logDownloadReportAdmin({
                                          adminName: adminName1,
                                          patientId: patient?.ID || encrypt(databaseId),
                                          patientName: patient?.FullName || "Unknown",
                                          reportUrl: foundReportURL,
                                          success: false,
                                          failureReason: error.message || "Failed to download the file"
                                        });
                                      }
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                  />
                                </Tooltip>
                              </>
                            ) : (
                              <>
                                <Tooltip title="Report not available" arrow>
                                  <VisibilityOffOutlinedIcon
                                    onClick={async () => {
                                      const errorMsg = "Report not available";
                                      toast.info(errorMsg, {
                                        position: "top-center",
                                      });

                                      //deepaaudit logs - Log failed report view (not available)
                                      await logViewReportAdmin({
                                        adminName: adminName1,
                                        patientId: patient?.ID || encrypt(databaseId),
                                        patientName: patient?.FullName || "Unknown",
                                        reportUrl: "",
                                        success: false,
                                        failureReason: errorMsg
                                      });
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                      color: "gray",
                                    }}
                                  />
                                </Tooltip>
                                <Tooltip title="File not available" arrow>
                                  <FileDownloadOffOutlinedIcon
                                    onClick={() => {
                                      toast.info("File not available", {
                                        position: "top-center",
                                      });
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                      color: "gray",
                                    }}
                                  />
                                </Tooltip>
                              </>
                            )}

                            {/* Prescription */}
                            {(() => {
                              const latestPrescription =
                                getLatestPrescriptionURL(patient);
                              if (latestPrescription) {
                                const decryptedPrescriptionURL =
                                  decrypt(latestPrescription);
                                return (
                                  <Tooltip title="Prescription" arrow>
                                    <FontAwesomeIcon
                                      icon={faPrescription}
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "10px",
                                        fontSize: "12px",
                                      }}
                                      onClick={() => {
                                        window.open(
                                          decryptedPrescriptionURL,
                                          "_blank"
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                );
                              }
                              return (
                                <Tooltip
                                  title="No Prescription Available"
                                  arrow
                                >
                                  <FontAwesomeIcon
                                    icon={faPrescription}
                                    style={{
                                      cursor: "not-allowed",
                                      marginRight: "10px",
                                      color: "gray",
                                      opacity: 0.5,
                                    }}
                                  />
                                </Tooltip>
                              );
                            })()}

                            {/* 3D */}
                            {/* {(() => {
                              let threeDURL;
                              if (patient.Version === "03" && patient.uploads) {
                                const uploadKeys = Object.keys(patient.uploads)
                                  .filter((key) =>
                                    key.toLowerCase().startsWith("scan")
                                  )
                                  .map((key) => ({
                                    key,
                                    number: parseInt(
                                      key.replace("Scan", "").trim(),
                                      10
                                    ),
                                  }))
                                  .sort((a, b) => b.number - a.number);

                                for (const { key } of uploadKeys) {
                                  const upload = patient.uploads[key];
                                  if (
                                    upload.Dicom_3DURL &&
                                    upload.Dicom_3DURL !== "Not Uploaded" &&
                                    upload.Dicom_3DURL !== "NA"
                                  ) {
                                    threeDURL = upload.Dicom_3DURL;
                                    break;
                                  }
                                }
                              } else {
                                if (
                                  patient.Dicom_3DURL &&
                                  patient.Dicom_3DURL !== "Not Uploaded" &&
                                  patient.Dicom_3DURL !== "NA"
                                ) {
                                  threeDURL = patient.Dicom_3DURL;
                                }
                              }
                              if (threeDURL) {
                                return (
                                  <Tooltip title="3D View" arrow>
                                    <ThreeDRotationIcon
                                      onClick={() => {
                                        const decrypted3DURL =
                                          decrypt(threeDURL);                                        
                                        if (decrypted3DURL) {
                                          const encryptedURL =
                                            CryptoJS.AES.encrypt(
                                              decrypted3DURL,
                                              secretKey
                                            ).toString();
                                          const modelViewerURL = `https://health.easiofy.com/3dViewer/?src=${encodeURIComponent(
                                            encryptedURL
                                          )}`;
                                          
                                          window.open(modelViewerURL, "_blank");
                                        } else {
                                          toast.info(
                                            "3D view is not available",
                                            {
                                              position: "top-center",
                                            }
                                          );
                                        }
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </Tooltip>
                                );
                              }
                              return (
                                <Tooltip title="3D view not available" arrow>
                                  <ThreeDRotationIcon
                                    onClick={() => {
                                      toast.info("3D view is not available", {
                                        position: "top-center",
                                      });
                                    }}
                                    style={{
                                      cursor: "not-allowed",
                                      marginRight: "10px",
                                      color: "gray",
                                    }}
                                  />
                                </Tooltip>
                              );
                            })()} */}

                            {/* Upload Data */}
                            <Tooltip title="Upload Data" arrow>
                              <UploadFileOutlinedIcon
                                style={{
                                  cursor: "pointer",
                                  marginRight: "3px",
                                  fontSize: "20px",
                                }}
                                onClick={() =>
                                  navigate(
                                    `/Technician/AddImage/${id}?page=${currentPage}&from=AssignDoctor`
                                  )
                                }
                              />
                            </Tooltip>

                            {/* Share */}
                            <Tooltip title="Share" arrow>
                              <ShareIcon
                                onClick={() => handleShareClick(id)}
                                style={{
                                  cursor: "pointer",
                                  marginRight: "10px",
                                }}
                              />
                            </Tooltip>

                            {/* Delete */}
                            <Tooltip title="Delete Patient" arrow>
                              <i
                                className="fas fa-trash"
                                onClick={() => handleDeletePatient(id)}
                                style={{
                                  cursor: "pointer",
                                  marginRight: "15px",
                                  fontSize: "17px",
                                }}
                              ></i>
                            </Tooltip>

                            {/* AI */}
                            {canShowAI ? (
                                <Tooltip
                                  title={
                                    patient.AI_result
                                      ? "Already generated"
                                      : "Generate AI"
                                  }
                                  arrow
                                >
                                  <span>
                                    <button
                                      onClick={() => handleAI(id)}
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "10px",
                                      }}
                                      disabled={Boolean(patient.AI_result)}
                                    >
                                      AI
                                    </button>
                                  </span>
                                </Tooltip>
                            ) : null}
                            {/* Reset AI */}
                            {/* {patient.AI_result && (
                              <Tooltip title="Reset AI Results" arrow>
                                <RestartAltIcon
                                  onClick={() => handleResetAI(id)}
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "10px",
                                    fontSize: "20px",
                                  }}
                                />
                              </Tooltip>
                            )} */}
                            {/* Priority Checkbox - TODO: Work on this feature in future */}
                            {/* <Tooltip 
                              title={
                                patient.Report_Status === "Final" 
                                  ? "Report Completed"
                                  : (patient.isPriority ? "Remove Priority" : "Mark as Priority")
                              } 
                              arrow
                            >
                              <input
                                type="checkbox"
                                checked={patient.Report_Status === "Final" ? true : Boolean(patient.isPriority)}
                                disabled={patient.Report_Status === "Final"}
                                onChange={() => handleTogglePriority(id, patient.isPriority || false)}
                                style={{
                                  cursor: patient.Report_Status === "Final" ? "not-allowed" : "pointer",
                                  width: "20px",
                                  height: "20px",
                                  marginRight: "10px",
                                  accentColor: "#4caf50",
                                  transform: "scale(1.1)",
                                }}
                              />
                            </Tooltip> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : isLoadingPatients ? (
                  // deepa bug fix - Show loading spinner instead of "No patients found" during loading
                  <tr>
                    <td colSpan="15" className="text-center" style={{ padding: "40px" }}>
                      <CircularProgress size={30} />
                      <div style={{ marginTop: "10px", color: "#666" }}>Loading patients...</div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      No patients found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginTop: "20px",
              gap: "15px",
            }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(event, value) => paginate(value)}
              siblingCount={1}
              boundaryCount={1}
              color="primary"
              showFirstButton
              showLastButton={false}
            />
            
            {isLoadingBatch && (
              <div style={{
                padding: "10px 20px",
                fontSize: "14px",
                color: "#007bff",
                fontWeight: "600",
              }}>
                Loading more patients...
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Export CSV Modal */}
      {isModalOpen && (
        <div className="export-data-overlay" onClick={handleCloseModal}>
          <div
            className="export-data-container"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="export-data-header">
              <h2>Select Date Range for Exporting Patient's Data</h2>
              <button
                className="export-data-close-btn"
                onClick={handleCloseModal}
              >
                &times;
              </button>
            </div>
            <div className="export-data-body">
              <label htmlFor="start-date">Start Date:</label>
              <input
                type="date"
                id="start-date"
                value={startDate ? startDate.toISOString().split("T")[0] : ""}
                onChange={(e) => {
                  const dateValue = e.target.value
                    ? new Date(e.target.value)
                    : null;
                  setStartDate(dateValue);
                }}
              />
              <br />
              <label htmlFor="end-date">End Date: </label>
              <input
                type="date"
                id="end-date"
                value={endDate ? endDate.toISOString().split("T")[0] : ""}
                onChange={(e) => {
                  const dateValue = e.target.value
                    ? new Date(e.target.value)
                    : null;
                  setEndDate(dateValue);
                }}
                min={startDate ? startDate.toISOString().split("T")[0] : ""}
              />
            </div>
            <div className="export-data-footer">
              <Button onClick={handleExportClick} className="export-data-btn">
                Export
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Clinical History Modal */}
      {clinicalHistoryModalVisible && (
        <div
          className="ClinicalHistory-modal-background"
          onClick={() => setClinicalHistoryModalVisible(false)}
        >
          <div
            className="ClinicalHistory-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ClinicalHistory-modal-header">
              <h2>View Clinical History</h2>
              <span
                className="ClinicalHistory-close-btn"
                onClick={() => setClinicalHistoryModalVisible(false)}
              >
                &times;
              </span>
            </div>
            <div className="ClinicalHistory-modal-body">
              <div className="form-group">
                <label htmlFor="clinicalHistoryTextarea"></label>
                <textarea
                  id="clinicalHistoryTextarea"
                  value={clinicalHistoryText}
                  className="form-control"
                  rows="4"
                  readOnly
                />
              </div>
              {attachedFile && (
                <div className="form-group">
                  <label>Attached File:</label>
                  <a
                    href={attachedFile.name}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Show File
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Bulk Assign Modal */}
      {bulkAssignModalVisible && (
        <div
          className="BulkAssignDoc-modal-background"
          onClick={() => setBulkAssignModalVisible(false)}
        >
          <div
            className="BulkAssignDoc-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="BulkAssignDoc-modal-header">
              <h2>Assign Patients in Bulk</h2>
              <span
                className="BulkAssignDoc-close-btn"
                onClick={() => setBulkAssignModalVisible(false)}
              >
                &times;
              </span>
            </div>
            <div className="BulkAssignDoc-modal-body">
              <h3>Select Patients</h3>
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setBulkSelectedPatients(unassignedPatients);
                  } else {
                    setBulkSelectedPatients([]);
                  }
                }}
                checked={
                  bulkSelectedPatients.length === unassignedPatients.length
                }
              />
              <label>Select All</label>
              <ul>
                {unassignedPatients.map((pid) => (
                  <li key={pid}>
                    <input
                      type="checkbox"
                      checked={bulkSelectedPatients.includes(pid)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setBulkSelectedPatients((prev) => [...prev, pid]);
                        } else {
                          setBulkSelectedPatients((prev) =>
                            prev.filter((patientId) => patientId !== pid)
                          );
                        }
                      }}
                    />
                    {posts[pid].FullName} ({posts[pid].ID})
                  </li>
                ))}
              </ul>
              <h3>Select Doctor</h3>
              <select
                value={bulkSelectedDoctor}
                onChange={(e) => setBulkSelectedDoctor(e.target.value)}
              >
                <option value="">Select Doctor</option>
                {(() => {
                  const uniqueDoctors = [];
                  let hodAdded = false;
                  
                  Object.keys(doctors).forEach((doctorKey) => {
                    const doctorName = doctors[doctorKey].Name;
                    const doctorRole = doctors[doctorKey].Role;
                    const isHOD = doctorRole && doctorRole.toLowerCase().includes('hod');
                    const isDoctorCommon = doctorRole && doctorRole.toLowerCase().includes('doctorcommon');
                    
                    // Skip DoctorCommon doctors
                    if (isDoctorCommon) {
                      return;
                    }
                    
                    // Add HOD only once
                    if (isHOD) {
                      if (!hodAdded) {
                        uniqueDoctors.push(
                          <option key="HOD" value="HOD">
                            HOD
                          </option>
                        );
                        hodAdded = true;
                      }
                    } else {
                      uniqueDoctors.push(
                        <option key={doctorKey} value={doctorName}>
                          {doctorName}
                        </option>
                      );
                    }
                  });
                  
                  return uniqueDoctors;
                })()}
              </select>
            </div>
            <div className="BulkAssignDoc-modal-footer">
              <Button
                variant="success"
                onClick={() => handleBulkAssign()}
                disabled={!bulkSelectedPatients.length || !bulkSelectedDoctor}
              >
                Assign
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Share Link Modal */}
      {modalVisible && (
        <div
          className="PatientViewData modal-background"
          onClick={() => setModalVisible(false)}
        >
          <div
            className="PatientViewData modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2 style={{ margin: "0 auto" }}>Share Patient Link</h2>
              <span
                className="close-btn"
                onClick={() => setModalVisible(false)}
              >
                &times;
              </span>
            </div>
            <div className="modal-body">
              <button
                onClick={copyToClipboard}
                className="modal-button copy-link"
              >
                <i className="fas fa-copy" style={{ marginRight: "8px" }}></i>
                Copy Link
              </button>
              <button
                onClick={shareViaWhatsApp}
                className="modal-button whatsapp-share"
              >
                <i
                  className="fab fa-whatsapp"
                  style={{ marginRight: "8px" }}
                ></i>
                WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}

      {/* AI Model Modal */}
      {aiModalVisible && aiModalPatientId && (
        <div
          className="ai-modal-overlay"
          onClick={() => {
            setAiModalVisible(false);
          }}
        >
          <div
            className="ai-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ai-modal-header">
              <h2>Select AI Model</h2>
              <button
                className="close-btn"
                onClick={() => {
                  setAiModalVisible(false);
                }}
              >
                &times;
              </button>
            </div>
            <div className="ai-modal-body">
              {(() => {
                const patient = posts[aiModalPatientId];
                const { xrayFracture, cxrTb, cxrTb2, cxrMulticlass, contourAbdomen, tumorAbdomen, threeDAbdomen, liverSegmentation, contourHaN } = getEnabledModels(patient);
                const mod = (getLatestModality(patient) || "").toLowerCase();
                const isXray =
                  mod.includes("xray") ||
                  mod.includes("x-ray") ||
                  mod.includes("xr") ||
                  mod.includes("x ray");
                const isCT = mod.includes("ct");

                return (
                  <ul>
                    {/* X-ray models */}
                    {isXray && (
                      <>
                        {/* CXR-Multiclass (displayed as CXR-TB-3) */}
                        {cxrMulticlass && (
                          <li
                            onClick={() =>
                              cxrMulticlass ? confirmCXRMulticlass(aiModalPatientId) : null
                            }
                            className="ai-model-option"
                            style={{
                              opacity: cxrMulticlass ? 1 : 0.5,
                              cursor: cxrMulticlass ? "pointer" : "not-allowed",
                            }}
                          >
                            CXR-TB-3
                          </li>
                        )}
                      </>
                    )}
                    {/* Other X-ray models - COMMENTED OUT */}
                    {/* {isXray && (
                      <>
                        {/* XRay Fracture * /}
                        <li
                          onClick={() =>
                            xrayFracture ? confirmBoneFracture(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: xrayFracture ? 1 : 0.5,
                            cursor: xrayFracture ? "pointer" : "not-allowed",
                          }}
                        >
                          XRay-Fracture
                        </li>

                        {/* CXR-TB * /}
                        <li
                          onClick={() =>
                            cxrTb ? confirmTBDetection(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: cxrTb ? 1 : 0.5,
                            cursor: cxrTb ? "pointer" : "not-allowed",
                          }}
                        >
                          CXR-TB
                        </li>
                        
                        {/* CXR-TB2 * /}
                        <li
                          onClick={() =>
                            cxrTb2 ? confirmTB2Detection(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: cxrTb2 ? 1 : 0.5,
                            cursor: cxrTb2 ? "pointer" : "not-allowed",
                          }}
                        >
                          CXR-TB2
                        </li>
                        
                        {/* CXR-Multiclass * /}
                        {cxrMulticlass && (
                          <li
                            onClick={() =>
                              cxrMulticlass ? confirmCXRMulticlass(aiModalPatientId) : null
                            }
                            className="ai-model-option"
                            style={{
                              opacity: cxrMulticlass ? 1 : 0.5,
                              cursor: cxrMulticlass ? "pointer" : "not-allowed",
                            }}
                          >
                            CXR-Multiclass
                          </li>
                        )}
                      </>
                    )} */}

                    {/* CT models - now showing as standalone models */}
                    {isCT && (
                      <>
                        {/* Contour-Abdomen */}
                        <li
                          onClick={() =>
                            contourAbdomen ? confirmContouringAbdomen(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: contourAbdomen ? 1 : 0.5,
                            cursor: contourAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          Contour-Abdomen
                        </li>
                        
                        {/* Tumor-Abdomen - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            tumorAbdomen ? confirmAbdomenTumorAnalysis(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: tumorAbdomen ? 1 : 0.5,
                            cursor: tumorAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          Tumor-Abdomen
                        </li> */}
                        
                        {/* 3D-Abdomen - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            threeDAbdomen ? confirm3DAbdomen(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: threeDAbdomen ? 1 : 0.5,
                            cursor: threeDAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          3D-Abdomen
                        </li> */}
                        {/* Liver-Segmentation - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            liverSegmentation ? confirmLiverSegmentation(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: liverSegmentation ? 1 : 0.5,
                            cursor: liverSegmentation ? "pointer" : "not-allowed",
                          }}
                        >
                          Liver-Segmentation
                        </li> */}
                        {/* Contour-HaN */}
                        <li
                                                  onClick={() =>
                          contourHaN ? confirmContourHaN(aiModalPatientId) : null
                        }
                          className="ai-model-option"
                          style={{
                            opacity: contourHaN ? 1 : 0.5,
                            cursor: contourHaN ? "pointer" : "not-allowed",
                          }}
                        >
                          Contour-HaN
                        </li>
                      </>
                    )}
                  </ul>
                );
              })()}
            </div>
            <div className="ai-modal-footer">
              <button
                onClick={() => {
                  setAiModalVisible(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Floating button to open AI tasks (only if we have tasks but the modal is fully closed) */}
      {aiTasks.length > 0 && !aiProcessingModalOpen && (
        <button
          className="open-ai-tasks-btn"
          onClick={() => setAiProcessingModalOpen(true)}
        >
          AI Tasks
        </button>
      )}

      {/* AI Processing Status Modal */}
      {aiTasks.length > 0 && aiProcessingModalOpen && (
        <div
          className="ai-processing-modal-overlay"
          style={{ display: aiProcessingModalMinimized ? "none" : "flex" }}
          onClick={() => {
            // click outside to close if you want
          }}
        >
          <div
            className="ai-processing-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ai-processing-modal-header">
              <h3>AI Processing Status</h3>
              <div className="ai-processing-header-buttons">
                <button
                  className="minimize-icon-btn"
                  onClick={() => setAiProcessingModalMinimized(true)}
                  title="Minimize"
                >
                  <MinimizeIcon />
                </button>
              </div>
            </div>
            <div className="ai-processing-modal-body">
              {aiTasks.map((task, idx) => (
                <div key={idx} className="ai-task-item">
                  <div>
                    <strong>Patient ID:</strong> {task.patientId}
                  </div>
                  <div>
                    <strong>Model:</strong> {task.model || "N/A"}
                    {task.subModel ? ` (${task.subModel})` : ""}
                  </div>
                  <div>
                    <strong>Status:</strong> {task.status}
                    {task.status &&
                      task.status.toLowerCase().includes("in-progress") && (
                        <CircularProgress
                          size={16}
                          style={{ color: "#000", marginLeft: "5px" }}
                        />
                      )}
                  </div>
                  {[
                    "done",
                    "failed",
                    "insufficient funds",
                    "server down",
                    "unknown id",
                  ].includes((task.status || "").toLowerCase()) && (
                    <button
                      className="clear-style-btn"
                      onClick={() => handleClearTask(idx)}
                    >
                      Clear
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Minimized Bar for AI Processing (if user hits "Minimize" but not "Close") */}
      {aiTasks.length > 0 &&
        aiProcessingModalOpen &&
        aiProcessingModalMinimized && (
          <div
            className="ai-processing-minimized-bar"
            onClick={() => setAiProcessingModalMinimized(false)}
          >
            <span style={{ fontWeight: "bold" }}>
              AI Tasks (click to expand)
            </span>
          </div>
        )}

      {insufficientBalanceModal.open && (
        <div
          className="insufficient-balance-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="insufficient-balance-modal-content"
            style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "32px",
              minWidth: "320px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
            }}
          >
            <h2 style={{ marginBottom: "16px", color: "#d32f2f" }}>
              Insufficient Balance
            </h2>
            <p style={{ marginBottom: "24px" }}>
              Not enough balance to run this AI model.
              <br />
              Please add funds to your wallet.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <button
                style={{
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  padding: "8px 18px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setInsufficientBalanceModal({ open: false, patientId: null });
                  navigate(`/Admin/Wallet/${adminName1}`, {
                    state: { redirectRoute: "/Admin" },
                  });
                }}
              >
                Add Balance
              </button>
              <button
                style={{
                  background: "#eee",
                  color: "#333",
                  border: "none",
                  borderRadius: "4px",
                  padding: "8px 18px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setInsufficientBalanceModal({ open: false, patientId: null })
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />

      <DoctorAssignmentLogs 
        show={showAuditLogs} 
        onHide={() => setShowAuditLogs(false)} 
      />
    </>
  
  );
};

export default AssignDoctor;
